<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title" class="mr-3"></page-header-title>
        <help-text
          v-if="course.num_places && Boolean(course.num_enrolled > course.num_places)"
          color="#dfa600"
          icon="warning"
          :tooltip="$t('courses.overbooked_tooltip')"
        />

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save(true, false)" :disabled="fieldDisabled" />

        <action-button type="export_excel" :text="$t('participants.title')" @click="exportExcel" />

        <action-button
          type="delete"
          @click="del(course.id)"
          v-if="course.id && course.num_enrolled == 0 && $can('course-delete') && modal != true"
        />
        <action-button
          type="delete"
          @click="cancel(course.id)"
          v-if="course.id && course.num_enrolled > 0 && course.status != 0 && $can('course-delete') && modal != true"
          :text="$t('courses.cancel_course')"
        />

        <v-btn icon @click="toggleCollapse" class="darken-2" v-if="!modal">
          <v-icon>{{ collapseExpandIcon }}</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="coursetemplate.coursetypegroup_id"
                  ref="coursetypegroup_id"
                  v-model="course.coursetypegroup_id"
                  class="required-field"
                  v-validate="'required'"
                  @change="courseGroupChange(course.coursetypegroup_id)"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.coursetypegroup_id')"
                  :disabled="Boolean(_.has(course, 'id') && course.coursetypegroup_id && course.coursetype_id && course.coursetemplate_id)"
                  clearable
                  v-if="!course.id && !id"
                ></v-autocomplete>
                <v-text-field
                  name="course.coursetypegroup_id"
                  v-model="course.coursetypegroup.name"
                  :label="$t('coursetypegroups.stitle')"
                  readonly
                  v-if="course.id"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="course.coursetype_id"
                  ref="coursetype_id"
                  v-model="course.coursetype_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.coursetype_id')"
                  :disabled="Boolean(_.has(course, 'id') && course.coursetypegroup_id && course.coursetype_id && course.coursetemplate_id)"
                  @change="courseTypeChange(course.coursetype_id)"
                  clearable
                  v-if="!course.id && !id"
                ></v-autocomplete>
                <v-text-field
                  name="course.coursetype_id"
                  v-model="course.coursetype.name"
                  :label="$t('coursetypes.title')"
                  readonly
                  v-if="course.id"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="course.coursetemplate_id"
                  ref="coursetemplate_id"
                  v-model="course.coursetemplate_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="coursetemplates"
                  item-text="name"
                  item-value="id"
                  :label="$t('coursetemplates.stitle')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.coursetemplate_id')"
                  :disabled="course.id && !isAdmin"
                  v-if="(course.id && isAdmin) || (!course.id && !id)"
                  @change="courseTemplateChange()"
                  clearable
                ></v-autocomplete>
                <v-text-field
                  name="course.coursetemplate_id"
                  v-model="coursetemplate.name"
                  :label="$t('coursetemplates.stitle')"
                  readonly
                  v-if="course.id && !isAdmin"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="course.coursetemplate_id">
                <v-text-field
                  name="course.name"
                  v-model="course.name"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('courses.name')"
                  :error-messages="errors.collect('course.name')"
                  :disabled="fieldDisabled"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="course.coursetemplate_id">
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.certificate_display_name"
                  v-model="course.certificate_display_name"
                  :label="$t('coursetemplates.certificate_display_name')"
                  :error-messages="errors.collect('course.certificate_display_name')"
                  :disabled="fieldDisabled"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-autocomplete
                                    name="course.class_id"
                                    v-model="course.class_id"
                                    v-validate="''"
                                    :items="classes"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('classes.title')"
                                    autocomplete="new-password"
                                    :error-messages="errors.collect('course.class_id')"
                                    :disabled="fieldDisabled"
                                    clearable
                                ></v-autocomplete>
                            </v-flex>-->
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="course.instructor_id"
                  v-model="course.instructor_id"
                  :items="filteredInstructors"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('courses.instructor_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.instructor_id')"
                  :disabled="fieldDisabled"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="course.stand_in"
                  v-model="course.stand_in"
                  :items="filteredInstructors"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('courses.stand_in')"
                  autocomplete="new-password"
                  :disabled="fieldDisabled"
                  clearable
                  multiple
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="course.company_id"
                  v-model="course.company_id"
                  :items="companies"
                  item-text="custom_name_1"
                  item-value="id"
                  :label="$t('courses.company_internal_select')"
                  autocomplete="new-password"
                  :disabled="fieldDisabled"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-autocomplete
                  name="course.address_id"
                  ref="address_id"
                  v-model="course.address_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="addresses"
                  @change="addressChange(course.address_id)"
                  item-text="full_address"
                  item-value="id"
                  :label="$t('addresses.stitle')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.address_id')"
                  :disabled="fieldDisabled"
                  clearable
                >
                  <template v-slot:append-outer>
                    <action-button type="new" :icon_only="true" small @click="showForm(null, 'address', null, null)" />
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-autocomplete
                  name="course.classroom_id"
                  v-model="course.classroom_id"
                  :items="classrooms"
                  item-text="name"
                  item-value="id"
                  :label="$t('classrooms.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.classroom_id')"
                  :disabled="fieldDisabled"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-select
                  name="course.status"
                  v-model="course.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="statuses"
                  :label="$t('courses.status')"
                  :error-messages="errors.collect('course.status')"
                  :disabled="fieldDisabled"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg1 md2 sm6 xs6 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="course.num_places"
                  class="required-field"
                  v-validate="'required|numeric'"
                  v-model="course.num_places"
                  :label="$t('courses.num_places')"
                  :error-messages="errors.collect('course.num_places')"
                  :disabled="fieldDisabled"
                  @keypress="$keyDown_IntOnly($event)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md2 sm6 xs6 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="course.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('courses.price')"
                  :error-messages="errors.collect('course.price')"
                  :disabled="fieldDisabled"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                    name="course.location"
                                    v-model="course.location"
                                    :label="$t('courses.location')"
                                    :error-messages="errors.collect('course.location')"
                                    :disabled="fieldDisabled"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->

              <v-flex lg2 md3 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-checkbox v-model="course.allow_overbook" :disabled="fieldDisabled">
                  <template slot="label">
                    {{ $t("courses.allow_overbook") }}
                    <span class="ml-1"><help-text slot="append" :tooltip="$t('courses.allow_overbook_helptext')" /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-checkbox v-model="course.allow_reservation" :disabled="fieldDisabled">
                  <template slot="label">
                    {{ $t("courses.allow_reservation") }}
                    <span class="ml-1"><help-text slot="append" :tooltip="$t('courses.allow_reservation_helptext')" /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-checkbox v-model="course.is_published" :label="$t('courses.is_published')" :disabled="fieldDisabled">
                  <template slot="label">
                    {{ $t("courses.is_published") }}
                    <span class="ml-1"><help-text slot="append" :tooltip="$t('courses.is_published_helptext')" /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-checkbox
                  v-model="course.send_email_notification"
                  :label="$t('courses.send_email_notification')"
                  :disabled="fieldDisabled"
                ></v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-checkbox
                  v-model="course.send_sms_notification"
                  :label="$t('courses.send_sms_notification')"
                  :disabled="fieldDisabled || !Boolean(organisation.sms_service)"
                ></v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="integration_klarna">
                <v-checkbox v-model="course.klarna_checkout" :label="$t('coursetemplates.klarna_checkout')" :disabled="fieldDisabled">
                  <help-text slot="append" :tooltip="$t('coursetemplates.klarna_checkout_type_helptext')" />
                </v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="integration_klarna && course.klarna_checkout">
                <v-select
                  name="coursetemplate.klarna_checkout.type"
                  v-model="course.klarna_checkout_type"
                  item-text="text"
                  item-value="key"
                  :items="$dd_klarna_checkout_type()"
                  :label="$t('coursetemplates.klarna_checkout_type')"
                  :disabled="fieldDisabled"
                ></v-select>
              </v-flex>
              <v-flex lg2 md3 sm6 xs8 v-if="coursetemplate.type == 2 && coursetemplate.valid_for">
                <v-dialog ref="dialog" v-model="cvu_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="course.certificate_valid_until"
                      v-model="computedCertValidUntil"
                      :label="$t('courses.certificate_valid_until')"
                      v-validate="'validDate'"
                      :error-messages="errors.collect('course.certificate_valid_until')"
                      append-icon="event"
                      @click:append="cvu_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      :disabled="fieldDisabled"
                    >
                      <help-text slot="append-outer" :tooltip="$t('courses.certificate_valid_until_helptext')" />
                    </v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="course.certificate_valid_until"
                    first-day-of-week="1"
                    :disabled="fieldDisabled"
                    :locale="$locale_bcp47()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="cvu_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12>
                <v-tooltip v-model="showEnrolmentFormLinkCopiedToolTip" bottom color="primary" nudge-bottom="-20">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="enrolment_form_link"
                      :readonly="true"
                      prepend-icon="link"
                      append-outer-icon="open_in_new"
                      @click:append-outer="redirectToEnrolmentForm"
                      @click="copyEnrolmentFormLink"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <span>{{ $t("global.copied") }}</span>
                </v-tooltip>

                <input class="d-none" type="text" :value="enrolment_form_link" id="copy-enrolment-form-link" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels
          v-model="clpsCourseDateExpand"
          class="cstm-filter mt-4 elevation-0"
          ref="attendees_expansion_panels"
          v-if="course.coursetemplate_id && coursetemplate.type == 1"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCourseDateIcon }}</v-icon>
                {{ $t("courses.course_dates") }}
                <span v-if="computedCourseStartDate"
                  >({{ $t("courses.date_text_clps", { day: course.number_of_days || 0, date: computedCourseStartDate }) }})</span
                >
              </span>
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex lg1 md2 sm6 xs6>
                  <v-text-field
                    name="course.number_of_days"
                    v-validate="'numeric'"
                    v-model="course.number_of_days"
                    :label="$t('courses.number_of_days')"
                    :error-messages="errors.collect('course.number_of_days')"
                    :disabled="fieldDisabled"
                    @keypress="$keyDown_IntOnly($event)"
                    @blur="numberOfDaysChange()"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md2 sm6 xs12>
                  <v-checkbox
                    v-model="course.exclude_weekends"
                    :label="$t('courses.exclude_weekends')"
                    :disabled="fieldDisabled"
                    @change="numberOfDaysChange"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex lg2 md2 sm6 xs12>
                  <v-checkbox
                    v-model="course.adjust_time_per_day"
                    :label="$t('courses.adjust_time_per_day')"
                    :disabled="fieldDisabled"
                    @change="adjustTimePerDayChange()"
                  ></v-checkbox>
                </v-flex>
                <v-flex lg2 md2 sm6 xs12>
                  <v-checkbox
                    v-model="course.register_attendance"
                    :label="$t('courses.register_attendance')"
                    :disabled="fieldDisabled || course.has_attendance"
                    @change="updateSingleCourseField(course.id, 'register_attendance', course.register_attendance)"
                  >
                    <template slot="label">
                      {{ $t("courses.register_attendance") }}
                      <span class="ml-1"><help-text slot="append" :tooltip="$t('courses.register_attendance_helper')" /></span>
                    </template>
                  </v-checkbox>
                </v-flex>
                <v-flex xs12></v-flex>
                <v-flex lg2 md3 sm6 xs8>
                  <v-dialog ref="dialog" v-model="start_date_menu" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        name="course.start_date"
                        v-model="computedCourseStartDate"
                        :label="$t('courses.start_date')"
                        class="required-field"
                        v-validate="'required|validDate'"
                        :error-messages="errors.collect('course.start_date')"
                        append-icon="event"
                        @click:append="start_date_menu = true"
                        :hint="'Format: ' + DATE_FORMAT"
                        :disabled="fieldDisabled"
                        @change="startDateTimeChange"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="course.start_date"
                      first-day-of-week="1"
                      @change="startDateTimeChange"
                      :disabled="fieldDisabled"
                      :locale="$locale_bcp47()"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="start_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg2 md3 sm6 xs4>
                  <v-dialog ref="dialog" v-model="start_time_menu" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        name="course.start_time"
                        v-model="computedCourseStartTime"
                        :label="$t('courses.start_time')"
                        class="required-field"
                        v-validate="'required|validTime'"
                        :error-messages="errors.collect('course.start_time')"
                        append-icon="schedule"
                        @click:append="start_time_menu = true"
                        :hint="'Format: ' + TIME_FORMAT"
                        :disabled="fieldDisabled"
                        @change="startDateTimeChange"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      color="primary"
                      v-model="course.start_time"
                      format="24hr"
                      @change="startDateTimeChange"
                      :disabled="fieldDisabled"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="start_time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg2 md3 sm6 xs8>
                  <v-dialog ref="dialog" v-model="end_date_menu" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        name="course.end_date"
                        v-model="computedCourseEndDate"
                        :label="$t('courses.end_date')"
                        class="required-field"
                        v-validate="'required|validDate'"
                        :error-messages="errors.collect('course.end_date')"
                        append-icon="event"
                        @click:append="end_date_menu = true"
                        @change="endDateTimeChange"
                        :hint="'Format: ' + DATE_FORMAT"
                        :disabled="fieldDisabled"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="course.end_date"
                      first-day-of-week="1"
                      :disabled="fieldDisabled"
                      :locale="$locale_bcp47()"
                      :min="course.start_date"
                      @change="endDateTimeChange"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="end_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg2 md3 sm6 xs4>
                  <v-dialog ref="dialog" v-model="end_time_menu" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        name="course.end_time"
                        v-model="computedCourseEndTime"
                        :label="$t('courses.end_time')"
                        class="required-field"
                        v-validate="'required|validTime'"
                        :error-messages="errors.collect('course.end_time')"
                        append-icon="schedule"
                        @click:append="end_time_menu = true"
                        @change="endDateTimeChange"
                        :hint="'Format: ' + TIME_FORMAT"
                        :disabled="fieldDisabled"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      color="primary"
                      v-model="course.end_time"
                      format="24hr"
                      :disabled="fieldDisabled"
                      :min="course.start_time"
                      @change="endDateTimeChange"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="end_time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg2 md3 sm6 xs8>
                  <v-dialog ref="dialog" v-model="enr_due_date_menu" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        name="course.enrolment_due_date"
                        v-model="computedEnrDueDate"
                        :label="$t('courses.enrolment_due_date')"
                        class="required-field"
                        v-validate="'required|validDate'"
                        :error-messages="errors.collect('course.enrolment_due_date')"
                        append-icon="event"
                        @click:append="enr_due_date_menu = true"
                        :hint="'Format: ' + DATE_FORMAT"
                        :disabled="fieldDisabled"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="course.enrolment_due_date"
                      first-day-of-week="1"
                      :disabled="fieldDisabled"
                      :locale="$locale_bcp47()"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="enr_due_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg2 md3 sm6 xs8></v-flex>
                <v-flex lg2 md3 sm6 xs8>
                  <v-dialog ref="dialog" v-model="cert_issued_date_menu" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        name="course.certificate_issued_date"
                        v-model="computedCertIssuedDate"
                        :label="$t('courses.certificate_issued_date')"
                        class="required-field"
                        v-validate="'required|validDate'"
                        :error-messages="errors.collect('course.certificate_issued_date')"
                        append-icon="event"
                        @click:append="cert_issued_date_menu = true"
                        :hint="'Format: ' + DATE_FORMAT"
                        :disabled="Boolean(!$hasRole('organisation-admin') && !$hasRole('mercantile-admin'))"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="course.certificate_issued_date"
                      first-day-of-week="1"
                      :disabled="Boolean(!$hasRole('organisation-admin') && !$hasRole('mercantile-admin'))"
                      :locale="$locale_bcp47()"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="cert_issued_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg2 md3 sm6 xs8 v-if="coursetemplate.type == 1 && coursetemplate.valid_for">
                  <v-text-field
                    name="course.certificate_valid_until"
                    v-model="computedCertValidUntil"
                    :label="$t('courses.certificate_valid_until')"
                    :hint="'Format: ' + DATE_FORMAT"
                    :readonly="true"
                    autocomplete="new-password"
                  >
                    <help-text slot="append" :tooltip="$t('courses.certificate_valid_until_helptext')" />
                  </v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="ml-0 pl-0" width="100%"></v-divider>
                </v-flex>

                <!-- COURSE START/END TIME -->
                <v-flex xs12 md6 lg4>
                  <v-layout row wrap>
                    <v-flex xs12 v-for="(cet, index) in course_times" :key="index">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <!--<v-text-field
                            :value="cet.date"
                            :label="$t('drivingtests.date')"
                            append-icon="event"
                            :readonly="true"
                            autocomplete="new-password"
                          ></v-text-field>-->
                          <v-dialog ref="dialog" v-model="csd_dates_menu[cet.index]" persistent width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :name="$t('drivingtests.date') + ' [' + (cet.index + 1) + ']'"
                                v-model="cet.date_format"
                                :label="$t('drivingtests.date')"
                                class="required-field"
                                v-validate="'required|validDate'"
                                :error-messages="$validator.errors.collect($t('drivingtests.date') + ' [' + (cet.index + 1) + ']')"
                                append-icon="event"
                                @click:append="$set(csd_dates_menu, cet.index, true)"
                                :hint="'Format: ' + DATE_FORMAT"
                                autocomplete="new-password"
                                @change="csdTextChange(cet.index)"
                                :disabled="!course.adjust_time_per_day"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              color="primary"
                              v-model="cet.date"
                              first-day-of-week="1"
                              :locale="$locale_bcp47()"
                              @change="csdChange(cet.index)"
                              :disabled="!course.adjust_time_per_day"
                              :min="
                                typeof course_times[index - 1] === 'undefined' && cet.date
                                  ? undefined
                                  : moment
                                      .utc(course_times[index - 1].date)
                                      .add('days', 1)
                                      .format(MYSQL_DATE_FORMAT)
                              "
                              :max="
                                typeof course_times[index + 1] === 'undefined' && cet.date
                                  ? undefined
                                  : moment
                                      .utc(course_times[index + 1].date)
                                      .subtract('days', 1)
                                      .format(MYSQL_DATE_FORMAT)
                              "
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $set(csd_dates_menu, cet.index, false)
                                  csdChange(cet.index)
                                "
                                class="darken-2"
                                >{{ $t("global.ok") }}</v-btn
                              >
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-dialog ref="dialog" v-model="start_times_menu[cet.index]" persistent width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :name="$t('courses.start_time') + '[' + cet.index + ']'"
                                v-model="cet.start_time"
                                :label="$t('courses.start_time')"
                                class="required-field"
                                v-validate="'required|validTime'"
                                :error-messages="$validator.errors.collect($t('courses.start_time') + ' [' + cet.index + ']')"
                                append-icon="schedule"
                                @click:append="$set(start_times_menu, cet.index, true)"
                                :hint="'Format: ' + TIME_FORMAT"
                                :disabled="!course.adjust_time_per_day"
                                @change="startTimeChange(cet.index)"
                                autocomplete="new-password"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              color="primary"
                              v-model="cet.start_time"
                              format="24hr"
                              :disabled="!course.adjust_time_per_day"
                              @change="startTimeChange(cet.index)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="$set(start_times_menu, cet.index, false)" class="darken-2">{{
                                $t("global.ok")
                              }}</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-dialog ref="dialog" v-model="end_times_menu[cet.index]" persistent width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :name="$t('courses.end_time') + '[' + cet.index + ']'"
                                v-model="cet.end_time"
                                :label="$t('courses.end_time')"
                                class="required-field"
                                v-validate="'required|validTime'"
                                :error-messages="$validator.errors.collect($t('courses.end_time') + ' [' + cet.index + ']')"
                                append-icon="schedule"
                                @click:append="$set(end_times_menu, cet.index, true)"
                                :hint="'Format: ' + TIME_FORMAT"
                                :disabled="!course.adjust_time_per_day"
                                @change="endTimeChange(cet.index)"
                                autocomplete="new-password"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              color="primary"
                              v-model="cet.end_time"
                              format="24hr"
                              :disabled="!course.adjust_time_per_day"
                              @change="endTimeChange(cet.index)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="$set(end_times_menu, cet.index, false)" class="darken-2">{{
                                $t("global.ok")
                              }}</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsAttendeeExpand"
          class="cstm-filter mt-4 elevation-0"
          ref="attendees_expansion_panels"
          v-if="course.id && course.coursetemplate_id && !modal"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsAttendeeIcon }}</v-icon>
                {{ $t("attendees.list_title") }} ({{ attendee_total }})

                <span class="subtitle ml-3" v-if="selectedAttendees.length > 0">({{ selectedAttendees.length }} selected)</span>
              </span>

              <v-spacer></v-spacer>

              <v-layout row wrap class="pa-0 mt-0">
                <v-flex xs12 class="pa-0">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-text-field
                        :label="$t('global.search')"
                        v-model="search_attendees_params.any"
                        @keydown="checkKeyPressFilterAttendees"
                        hide-details
                        dark
                        class="pa-0 ma-0 search-tf-bar-ph"
                        @click.stop="() => {}"
                        autocomplete="new-password"
                      ></v-text-field>
                      <router-link :to="BACKEND_URL + '/accomplishment/' + course.id" class="d-content" @click.prevent="click">
                        <action-button
                          type="default"
                          small
                          icon="fas fa-check-square"
                          color="success"
                          :text="$t('attendees.accomplishment')"
                        />
                      </router-link>
                      <router-link
                        :to="BACKEND_URL + '/courses/attendance/' + course.id"
                        class="d-content"
                        @click.prevent="click"
                        v-if="course.register_attendance && coursetemplate.type == 1"
                      >
                        <action-button type="default" small icon="fas fa-user-check" color="success" :text="$t('courses.attendance')" />
                      </router-link>

                      <v-btn color="success" small class="cstm-v-btn darken-2" @click.stop="partlistpopup_show">
                        <v-icon small>fas fa-plus</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                      </v-btn>

                      <v-btn
                        class="cstm-v-btn darken-2"
                        color="success"
                        @click.stop="sendemailtemplatepopup_show('attendee')"
                        small
                        v-if="selectedAttendees.length > 0"
                      >
                        <v-icon small>fas fa-paper-plane</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.notify") }}</span>
                      </v-btn>

                      <v-btn
                        class="cstm-v-btn darken-2"
                        color="error"
                        @click.stop="deleteSelectedAttendees"
                        small
                        v-if="selectedAttendees.length > 0 && coursetemplate.type == 2"
                      >
                        <v-icon small>fas fa-times</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.delete_selected") }}</span>
                      </v-btn>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="attendee_headers"
                  :items="attendees"
                  :items-per-page="attendees.length"
                  :options.sync="attendee_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="attendee_total"
                  :loading="attendee_show_loading"
                  :expanded.sync="expanded"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  v-model="selectedAttendees"
                  show-expand
                  :show-select="true"
                  :must-sort="true"
                >
                  <template v-slot:item.student_name="{ item }">
                    <router-link :to="BACKEND_URL + '/participants/edit/' + item.participant_id" class="d-content" @click.prevent="click">
                      {{ item.participant.first_name + " " + item.participant.last_name }}
                    </router-link>
                    <v-icon
                      class="ml-3 enable-internal-note"
                      color="black"
                      small
                      v-if="
                        item.participant.courses.find(
                          (i) => i.tenant_attendee_id == item.id && i.tenant_course_id == course.id && i.comment
                        )
                      "
                      >fas fa-comment</v-icon
                    >
                  </template>

                  <template v-slot:item.date_of_birth="{ item }">
                    {{ item.participant.date_of_birth ? moment.utc(item.participant.date_of_birth).format(DATE_FORMAT) : "" }}
                  </template>

                  <template v-slot:item.company="{ item }">
                    {{ item.companies ? item.companies.map((i) => i.name).join(", ") : "" }}
                  </template>

                  <template v-slot:item.image_updated_at="{ item }">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn text icon class="darken-2" v-on="on" v-bind="attrs" v-if="item.participant_image == null">
                          <v-icon>camera_alt</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="(selection, index) in uploadSelections" :key="index">
                          <v-list-item-title @click="openUpload(selection.key, item.participant_id)">{{
                            selection.label
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <span v-if="item.participant_image != null && item.participant_image_verified == 1">{{
                      moment(item.participant_image_updated_at).format(DATE_FORMAT)
                    }}</span>
                    <span v-if="item.participant_image != null && item.participant_image_verified != 1">{{
                      $t("participants.not_verified")
                    }}</span>
                  </template>

                  <template v-slot:item.course_completed="{ item }">
                    <v-checkbox
                      class="justify-center"
                      v-model="item.course_completed"
                      @change="updateSingleField(item.id, 'course_completed', item.course_completed)"
                    ></v-checkbox>
                  </template>

                  <template v-slot:item.documents_provided="{ item }">
                    <v-checkbox
                      class="justify-center"
                      v-model="item.documents_provided"
                      @change="updateSingleField(item.id, 'documents_provided', item.documents_provided)"
                    ></v-checkbox>
                  </template>

                  <template v-slot:item.met_up_days="{ item }">
                    {{ item.attendance_percentage + "%" }}
                  </template>

                  <template v-slot:item.release_certificate="{ item }">
                    <v-checkbox
                      dense
                      hide-details
                      v-model="item.release_certificate"
                      class="align-center justify-center d-grid acc-chkbox"
                      readonly
                      v-if="item.release_certificate"
                    />
                  </template>

                  <template v-slot:item.accomplishment_total="{ item }">
                    {{ item.accomplishment_total + "%" }}
                  </template>

                  <template v-slot:item.theory_test="{ item }">
                    <v-select
                      item-text="text"
                      item-value="key"
                      :items="$dd_attendees_theory_test()"
                      v-model="item.theory_test"
                      @change="updateSingleField(item.id, 'theory_test', item.theory_test)"
                    ></v-select>
                  </template>

                  <template v-slot:item.certificate="{ item }">
                    <v-btn
                      text
                      icon
                      v-if="
                        item.participant.date_of_birth &&
                        (item.accomplishment_total == 100 || (coursetemplate.type == 2 && item.accomplishment_total > 0))
                      "
                      @click="downloadCertificate(item)"
                      class="darken-2"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:item.p360="{ item }">
                    <div v-if="item.accomplishment_total == 100 && !item.p360_archived_date">
                      <v-btn text icon @click="p360Upload(item)" class="darken-2" :color="'primary'">
                        <v-icon>open_in_new</v-icon>
                      </v-btn>

                      <v-tooltip
                        bottom
                        v-if="!item.p360_archived_date && !item.certificate_filename && item.p360_log_id && item.p360_log_date"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small color="error" v-on="on" v-bind="attrs">info</v-icon>
                        </template>
                        <span>{{
                          $t("integrations.p360_upload_failed_date", {
                            date: moment.utc(item.p360_log_date).format(DATE_FORMAT + " " + TIME_FORMAT)
                          })
                        }}</span>
                      </v-tooltip>
                    </div>
                    <span v-if="item.p360_archived_date && item.certificate_filename">{{
                      item.p360_archived_date ? moment.utc(item.p360_archived_date).format(DATE_FORMAT + " " + TIME_FORMAT) : ""
                    }}</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button
                      type="delete"
                      class="enable-attendee-deletion"
                      :icon_only="true"
                      @click="showMoveAttendee(item.id)"
                      v-if="$can('attendee-delete') && !item.attendance_percentage && !item.accomplishment_total"
                      small
                    />
                  </template>

                  <template v-slot:expanded-item="{ item }">
                    <td :colspan="12">
                      <attendeeCourseDetails :id="item.id" :course_id="course.id" @callback_attendee_updated="callback_attendee_updated" />
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsEnrolmentExpand"
          class="cstm-filter mt-4 elevation-0"
          v-if="course.id && course.coursetemplate_id && !modal"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsEnrolmentIcon }}</v-icon>
                {{ $t("enrolments.list_title") }} ({{ enr_total }})
                <span class="subtitle ml-3" v-if="selectedEnrolments.length > 0">({{ selectedEnrolments.length }} selected)</span>
              </span>

              <v-spacer></v-spacer>

              <v-flex xs2>
                <v-checkbox
                  v-model="requestOnly"
                  hide-details
                  small
                  dark
                  class="mandatory-chkbox float-right"
                  :label="$t('courses.show_requests_only')"
                  @click.stop="() => {}"
                  v-if="moment().isSameOrBefore(predata.start_date, 'date')"
                />
              </v-flex>
              <v-flex xs3>
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2 float-right"
                  color="success"
                  @click.stop="sendemailtemplatepopup_show('enrolment')"
                  small
                  v-if="selectedEnrolments.length > 0"
                >
                  <v-icon small>fas fa-paper-plane</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.notify") }}</span>
                </v-btn>

                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2 float-right"
                  color="success"
                  @click.stop="show_partAndEnrPopup"
                  small
                  v-if="moment().isSameOrBefore(predata.start_date, 'date')"
                >
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{
                    requestOnly ? $t("courses.select_requests_only") : $t("courses.select_students")
                  }}</span>
                </v-btn>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  ref="enrTable"
                  :headers="enr_headers"
                  :items="enrolments"
                  :items-per-page="enrolments.length"
                  :options.sync="enr_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="enr_total"
                  :loading="enr_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :expanded.sync="expanded_enr"
                  v-model="selectedEnrolments"
                  show-expand
                  :show-select="true"
                  :must-sort="true"
                >
                  <template v-slot:item.name="{ item }">
                    <input :id="'enr-row-' + item.id" style="width: 0" />
                    <!-- Placeholder to know where to scroll if this.autoOpenEnrolment has value -->
                    <span v-if="item.status != 6">
                      {{ item.first_name }} {{ item.last_name }}
                      <v-icon class="ml-3 enable-internal-note" color="black" small v-if="item.internal_notes">fas fa-comment</v-icon>
                    </span>
                    <span v-else> Reserved: {{ item.organisation.req_first_name }} {{ item.organisation.req_last_name }} </span>
                  </template>

                  <template v-slot:item.email="{ item }">
                    <span v-if="item.status != 6">
                      {{ item.email }}
                    </span>
                    <span v-else>
                      {{ item.organisation.req_email }}
                    </span>
                  </template>

                  <template v-slot:item.mobile="{ item }">
                    <span v-if="item.status != 6">
                      {{ item.mobile }}
                    </span>
                    <span v-else>
                      {{ item.organisation.req_mobile }}
                    </span>
                  </template>

                  <template v-slot:item.course="{ item }">
                    {{ item.course.name }}
                  </template>

                  <template v-slot:item.company="{ item }">
                    {{ item.organisation.name || "" }}
                  </template>

                  <template v-slot:item.date_of_birth="{ item }">
                    <span v-if="item.status != 6">
                      {{ item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : "" }}
                    </span>
                    <span v-else></span>
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{ item.created_at ? moment.utc(item.created_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button
                      type="add_to_participant"
                      :icon_only="true"
                      @click="callback_enrverify_show(item.id)"
                      v-if="$can('participant-access') && item.status != 6"
                      small
                    />

                    <action-button
                      type="edit"
                      :icon_only="true"
                      @click="showForm(item.id, 'enrolment-basic', null, null)"
                      v-if="$can('enrolment-edit')"
                      :text="$t('enrolments.enrolment_edit')"
                      small
                    />

                    <action-button
                      type="close"
                      :icon_only="true"
                      @click="showMoveEnrolment(item.id)"
                      v-if="$can('participant-access')"
                      small
                    />
                  </template>
                  <template v-slot:expanded-item="{ item }">
                    <td :colspan="9">
                      <v-container grid-list-md class="ma-0 pa-0">
                        <v-layout row wrap class="py-4">
                          <v-flex md8>
                            <v-layout row wrap>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.first_name"
                                  v-model="item.first_name"
                                  :label="$t('enrolments.p_first_name')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.last_name"
                                  v-model="item.last_name"
                                  :label="$t('enrolments.p_last_name')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.email"
                                  v-model="item.email"
                                  :label="$t('enrolments.p_email')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.mobile"
                                  v-model="item.mobile"
                                  :label="$t('enrolments.p_mobile')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.date_of_birth"
                                  :value="item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : ''"
                                  :label="$t('enrolments.p_date_of_birth')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.street"
                                  v-model="item.street"
                                  :label="$t('enrolments.p_address_street')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg1 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.zip"
                                  v-model="item.zip"
                                  :label="$t('enrolments.p_address_zip')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg2 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.city"
                                  v-model="item.city"
                                  :label="$t('enrolments.p_address_city')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.country"
                                  :value="$dd_countries(item.country)"
                                  :label="$t('enrolments.p_address_country')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.reference"
                                  v-model="item.reference"
                                  :label="$t('enrolments.o_reference')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12 v-if="item.organisation.name">
                                <v-text-field
                                  name="enrolments.o_name"
                                  v-model="item.organisation.name"
                                  :label="$t('enrolments.o_name')"
                                  readonly
                                  autocomplete="new-password"
                                >
                                  <template v-slot:append>
                                    <v-icon @click="orgRedirect(item.enrolment_organisation_id)" small color="grey lighten-1"
                                      >fas fa-link</v-icon
                                    >
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12 v-if="item.organisation.req_first_name || item.organisation.req_last_name">
                                <v-text-field
                                  name="enrolment.o_requestor"
                                  :value="item.organisation.req_first_name + ' ' + item.organisation.req_last_name"
                                  :label="$t('enrolments.o_requestor')"
                                  readonly
                                  autocomplete="new-password"
                                >
                                  <template v-slot:append>
                                    <v-icon @click="orgRedirect(item.enrolment_organisation_id)" small color="grey lighten-1"
                                      >fas fa-link</v-icon
                                    >
                                  </template>
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.invoice_email"
                                  :value="item.invoice_email"
                                  :label="$t('enrolments.invoice_email')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                  name="enrolment.enrolled"
                                  :value="item.created_at ? moment.utc(item.created_at).format(DATE_FORMAT + ' ' + TIME_FORMAT) : ''"
                                  :label="$t('enrolments.enrolled')"
                                  readonly
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-textarea
                                  name="enrolments.comment"
                                  v-model="item.comments"
                                  :label="$t('enrolments.comment')"
                                  no-resize
                                  readonly
                                ></v-textarea>
                              </v-flex>
                              <v-flex xs12 class="enable-internal-note">
                                <v-textarea
                                  name="enrolments.internal_notes"
                                  v-model="item.internal_notes"
                                  :label="$t('enrolments.internal_notes')"
                                  no-resize
                                  @change="updateSingleEnrField(item.id, 'internal_notes', item.internal_notes)"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex md4 class="pl-4">
                            <enrolmentDetails :id="Number(item.id)" />
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsCourseDocumentExpand"
          class="cstm-filter mt-4 elevation-0"
          ref="attendees_expansion_panels"
          v-if="course.id && course.coursetemplate_id && !modal"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCourseDocumentIcon }}</v-icon>
                {{ $t("courses.course_documents") }}
              </span>
              <v-spacer></v-spacer>

              <div class="text-right">
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2"
                  color="warning"
                  @click.stop="toggleDocumentList"
                  small
                  v-if="dc_total_deleted > 0 && dc_mode == null"
                >
                  <v-icon small>fas fa-trash-restore</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.show_deleted_documents") }}</span>
                </v-btn>

                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2"
                  color="info"
                  @click.stop="toggleDocumentList"
                  small
                  v-if="dc_mode == 'deleted'"
                >
                  <v-icon small>fas fa-arrow-left</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.show_documents") }}</span>
                </v-btn>

                <v-btn color="success" small class="cstm-v-btn darken-2" @click.stop="openUploadDocumentForm()">
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.add_documents") }}</span>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="dc_headers"
                    :items="documents"
                    :items-per-page="documents.length"
                    :options.sync="dc_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="dc_total"
                    :loading="dc_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.original_filename="{ item }">
                      {{ item.original_filename }}
                    </template>

                    <template v-slot:item.size="{ item }">
                      {{ $formatBytes(item.size) }}
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ moment.utc(item.created_at).format(DATE_FORMAT) + " " + moment.utc(item.created_at).format(TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.deleted_at="{ item }">
                      {{ moment.utc(item.deleted_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.deleted_on="{ item }">
                      {{ moment.utc(item.deleted_on).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <action-button v-if="!item.deleted_at" type="edit" @click="openUpdateFile(item)" :icon_only="true" />
                      <action-button
                        type="preview"
                        @click="downloadDocument(item, true)"
                        :icon_only="true"
                        v-if="$hasPreview(item.original_filename) && !item.deleted_at"
                      />
                      <action-button v-if="!item.deleted_at" type="download" @click="downloadDocument(item)" :icon_only="true" />

                      <action-button v-if="!item.deleted_at" type="delete" @click="deleteDocument(item.id)" :icon_only="true" />
                      <action-button v-if="item.deleted_at" type="restore" @click="restoreDocument(item)" :icon_only="true" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsCourseDescExpand"
          class="cstm-filter mt-4 elevation-0"
          ref="attendees_expansion_panels"
          v-if="course.coursetemplate_id"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCourseDescIcon }}</v-icon>
                {{ $t("courses.course_descriptions") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea
                    name="course.short_description"
                    v-model="course.short_description"
                    rows="1"
                    auto-grow
                    :label="$t('courses.short_description')"
                    :error-messages="errors.collect('course.short_description')"
                    :disabled="fieldDisabled"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    name="course.description"
                    v-model="course.description"
                    rows="3"
                    auto-grow
                    :label="$t('courses.description')"
                    :error-messages="errors.collect('course.description')"
                    :disabled="fieldDisabled"
                  ></v-textarea>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-tooltip v-model="showInfoLinkCopiedToolTip" bottom color="primary" nudge-bottom="-20">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        name="coursetemplate.info_link"
                        v-model="course.info_link"
                        v-validate="'max:255|url'"
                        :label="$t('coursetemplates.info_link')"
                        :error-messages="errors.collect('coursetemplate.info_link')"
                        :readonly="true"
                        :disabled="fieldDisabled"
                        prepend-icon="link"
                        append-outer-icon="open_in_new"
                        @click:append-outer="redirectToInfoLink"
                        @click="copyInfoLink"
                        autocomplete="new-password"
                      ></v-text-field>
                    </template>
                    <span>{{ $t("global.copied") }}</span>
                  </v-tooltip>
                  <input class="d-none" type="text" :value="course.info_link" id="copy-info-link" />
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsModuleTemplateExpand"
          class="cstm-filter mt-4 elevation-0"
          v-if="course.id && course.coursetemplate_id && !modal"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsModuleTemplateIcon }}</v-icon>
                {{ $t("moduletemplates.list_title") }}
              </span>

              <v-spacer></v-spacer>

              <div class="text-right">
                <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="modtemplistpopup_show" small>
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.select") }}</span>
                </v-btn>
                <v-btn color="success" small class="cstm-v-btn darken-2" @click.stop="showForm(null, 'coursemoduletemplate', 1, null)">
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <draggable v-model="cmDragged" handle=".drag-icon" class="full-width-draggable">
                  <v-flex xs12 v-for="moduletemplate in moduletemplates" :key="'mt-' + moduletemplate.id">
                    <v-card>
                      <v-card-title class="body-1 mt-card-title">
                        <div class="body-2">
                          <v-icon class="drag-icon mr-2" dark small>fas fa-grip-vertical</v-icon>
                          {{ moduletemplate.name }}
                        </div>
                        <div class="caption ml-2" v-if="coursetemplate.type == 1">
                          ({{ $t("moduletemplates.price") }}: {{ moduletemplate.price }})
                        </div>

                        <v-spacer></v-spacer>

                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.hide_in_accomplishment"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.hide_in_accomplishment") }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.hide_in_enrolment"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.hide_in_enrolment") }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.select_visibility"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $dd_select_visibility(moduletemplate.select_visibility) }}</v-chip
                        >
                        <v-chip
                          small
                          label
                          color="success darken-2"
                          class="mr-2"
                          v-if="moduletemplate.is_included && coursetemplate.type == 1"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.is_included") }}</v-chip
                        >
                        <v-checkbox
                          name="moduletemplate.mandatory"
                          class="mandatory-chkbox"
                          v-model="moduletemplate.mandatory"
                          @change="updateModuleTemplateMandatory(moduletemplate, $event)"
                          :label="$t('moduletemplates.mandatory')"
                          dark
                        ></v-checkbox>

                        <!--<v-chip small label color="success darken-2" class="mr-2">
                                                    <v-checkbox
                                                        name="moduletemplate.mandatory"
                                                        class="mandatory-chkbox mt-mandatory"
                                                        v-model="moduletemplate.mandatory"
                                                        @change="updateModuleTemplateMandatory(moduletemplate.id, $event)"
                                                        :label="$t('moduletemplates.mandatory')"
                                                        dense
                                                        dark
                                                        small   
                                                        :on-icon="'<v-icon small >home</v-icon>'"
                                                        :off-icon="'fas fa-check-square'"
                                                    ></v-checkbox>
                                                </v-chip>
                                                -->

                        <action-button
                          type="edit"
                          small
                          @click="showForm(moduletemplate.id, 'coursemoduletemplate', moduletemplate.manually_added, null)"
                          :icon_only="true"
                        />

                        <action-button
                          type="new"
                          small
                          @click="showForm(null, 'moduleoption', moduletemplate.id, course.coursetemplate_id)"
                          :icon_only="true"
                        />
                      </v-card-title>
                      <v-card-text v-if="moduletemplate.moduleoptions && moduletemplate.moduleoptions.length > 0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left" width="20%">{{ $t("moduleoptions.name") }}</th>
                                <th v-if="coursetemplate.type == 1" class="text-left" width="10%">
                                  {{ $t("moduleoptions.price") }}
                                </th>
                                <th class="text-left" width="10%">{{ $t("moduleoptions.hours") }}</th>
                                <th class="text-left" width="10%">
                                  {{ $t("moduleoptions.enrol_select") }}
                                </th>
                                <th class="text-left" width="10%">
                                  {{ $t("moduleoptions.mandatory_accomplishment") }}
                                </th>
                                <th class="text-left" width="10%">
                                  {{ $t("global.dd_select_visibility_expertise") }}
                                </th>
                                <th class="text-left" width="10%">
                                  {{ $t("global.dd_select_visibility_course_certificate") }}
                                </th>
                                <th class="text-end" width="12%">{{ $t("global.actions") }}</th>
                              </tr>
                            </thead>
                            <tbody v-for="(moduleoption, index) in moduletemplate.moduleoptions" :key="'mo-' + moduleoption.id">
                              <tr>
                                <td scope="row" :class="moduleoption.comment ? 'py-2' : ''">
                                  <v-btn
                                    icon
                                    color="grey"
                                    class="icon-order-btn"
                                    @click="moduleOptionOrder(moduletemplate.id, moduleoption.id, false)"
                                    v-if="index >= 1"
                                  >
                                    <v-icon>fas fa-angle-up</v-icon>
                                  </v-btn>
                                  <v-btn
                                    icon
                                    color="grey"
                                    class="icon-order-btn"
                                    @click="moduleOptionOrder(moduletemplate.id, moduleoption.id, true)"
                                    v-if="index <= moduletemplate.moduleoptions.length - 2"
                                  >
                                    <v-icon>fas fa-angle-down</v-icon>
                                  </v-btn>
                                  {{ moduleoption.name }}
                                  <p v-if="moduleoption.comment" class="font-italic mb-0">( {{ moduleoption.comment }} )</p>
                                </td>
                                <td v-if="coursetemplate.type == 1" scope="row">
                                  {{ moduleoption.price }}
                                </td>
                                <td scope="row">{{ moduleoption.hours }}</td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.enrol_select)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.mandatory_accomplishment)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.add_to_expertise)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.add_to_course_certificate)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td class="text-end" scope="row">
                                  <action-button
                                    type="new"
                                    small
                                    @click="showForm(null, 'moduleoptioncoursetype', moduleoption.id, course.coursetemplate_id)"
                                    :icon_only="true"
                                  />

                                  <action-button
                                    type="edit"
                                    :icon_only="true"
                                    small
                                    @click="showForm(moduleoption.id, 'moduleoption', moduletemplate.id, course.coursetemplate_id)"
                                  />
                                  <action-button
                                    type="delete"
                                    :icon_only="true"
                                    small
                                    @click="del_option(moduleoption.id)"
                                    v-if="moduleoption.admin_id == null"
                                  />
                                </td>
                              </tr>
                              <tr v-if="moduleoption.coursetypes && moduleoption.coursetypes.length > 0">
                                <td :colspan="8" class="ct-td">
                                  <v-card>
                                    <v-app-bar flat dense color="white">
                                      <v-toolbar-title class="body-2">{{ $t("coursetypes.title") }}</v-toolbar-title>
                                    </v-app-bar>
                                    <v-card-text class="pa-4">
                                      <v-simple-table>
                                        <template v-slot:default>
                                          <thead>
                                            <tr>
                                              <!--<th class="text-left">{{ $t('moduleoptioncoursetypes.coursetype_id') }}</th>-->
                                              <th class="text-left">
                                                {{ $t("moduleoptioncoursetypes.name") }}
                                              </th>
                                              <th class="text-left">
                                                {{ $t("moduleoptioncoursetypes.price") }}
                                              </th>
                                              <th class="text-end" width="20%">
                                                {{ $t("global.actions") }}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="coursetype in moduleoption.coursetypes">
                                              <tr :key="coursetype.id + '-td1'" :class="coursetype.comment ? 'tr-no-bottom-border' : ''">
                                                <!--<td scope="row">{{ coursetype.coursetype.category }}</td>-->
                                                <td scope="row">{{ coursetype.name }}</td>
                                                <td scope="row">{{ coursetype.price }}</td>
                                                <td scope="row" class="text-end">
                                                  <action-button
                                                    type="edit"
                                                    :icon_only="true"
                                                    small
                                                    @click="
                                                      showForm(
                                                        coursetype.id,
                                                        'moduleoptioncoursetype',
                                                        moduleoption.id,
                                                        course.coursetemplate_id
                                                      )
                                                    "
                                                  />
                                                  <action-button
                                                    type="delete"
                                                    :icon_only="true"
                                                    small
                                                    @click="del_option_ct(coursetype.id)"
                                                  />
                                                </td>
                                              </tr>
                                              <tr :key="coursetype.id + '-td2'" v-if="coursetype.comment">
                                                <td colspan="4">
                                                  <span> {{ $t("moduleoptioncoursetypes.comment") }}: {{ coursetype.comment }} </span>
                                                </td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                    </v-card-text>
                                  </v-card>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </draggable>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsNotificationLogExpand"
          class="cstm-filter mt-4 elevation-0"
          ref="notificationlog_expansion_panels"
          v-if="course.id && !modal"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsNotificationLogIcon }}</v-icon>
                {{ $t("notificationlogs.title") }}
              </span>
              <v-spacer></v-spacer>
              <div class="text-right">
                <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="notificationlog_list" small>
                  <v-icon small>fas fa-sync</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.refresh") }}</span>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="nl_headers"
                    :items="notificationlogs"
                    :items-per-page="notificationlogs.length"
                    :options.sync="nl_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="nl_total"
                    :loading="nl_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.type="{ item }">
                      <!--<v-chip color="grey" class="darken-2" dark label small>{{ item.type }}</v-chip>-->
                      {{ item.type }}
                    </template>
                    <template v-slot:item.subject="{ item }">
                      {{ item.type == "email" ? item.subject : item.message }}
                    </template>
                    <template v-slot:item.sender_name="{ item }">
                      {{
                        item.sender_user_id == -1 ? $t("notificationlogs.system_triggered") : item.sender_user_id ? item.sender_name : ""
                      }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip :color="item.status_color" class="darken-2" dark label small>{{ item.status }}</v-chip>
                    </template>
                    <template v-slot:item.date_sent="{ item }">
                      {{ item.date_sent ? moment.utc(item.date_sent).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-dialog v-model="showDialogForm" persistent max-width="75%">
          <div class="form-modal pa-4">
            <component
              :is="currentLoadedForm.form"
              :id="currentLoadedForm.id"
              :course_id="course.id"
              :course_type="coursetemplate.type"
              :moduletemplate_id="currentLoadedForm.moduletemplate_id"
              :moduleoption_id="currentLoadedForm.moduleoption_id"
              :coursetypes="currentLoadedForm.coursetypes"
              :manually_added="currentCMTManuallyAdded"
              :select_visibility="currentLoadedForm.select_visibility"
              :disable_accomp_select="currentLoadedForm.disable_accomp_select"
              :disable_enrol_select="currentLoadedForm.disable_enrol_select"
              :modal="true"
              :from_module="currentFromModule"
              :had_accomplishment_completed="hadAccomplishmentCompleted"
              @return_modal_form="return_modal_form"
              @return_modal_cancel_form="return_modal_cancel_form"
            ></component>
          </div>
        </v-dialog>

        <v-dialog v-model="showUploadForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-4">
                      <ValidationObserver ref="participant_image">
                        <v-flex xs12>
                          <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                            <v-file-input
                              v-model="participant_image"
                              accept=".jpg,.jpeg,.png"
                              color="primary"
                              counter
                              :placeholder="$t('courses.select_image')"
                              prepend-icon="attach_file"
                              outlined
                              :show-size="1000"
                              clearable
                              :error="errors.length > 0"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:selection="{ index, text }">
                                <v-chip color="primary" dark label small>
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </ValidationProvider>
                        </v-flex>
                      </ValidationObserver>
                      <v-flex xs12>
                        <v-card
                          @drop.prevent="documentOnDropImage($event)"
                          @dragover.prevent="document_dragover_image = true"
                          @dragenter.prevent="document_dragover_image = true"
                          @dragleave.prevent="document_dragover_image = false"
                          :class="{ 'grey lighten-2': document_dragover_image }"
                        >
                          <v-card-text>
                            <v-row class="d-flex flex-column" dense align="center" justify="center">
                              <v-icon :class="[document_dragover_image ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                              <p>{{ $t("global.drop_files_here") }}</p>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUpload" />
                      <action-button @click="uploadImage()" type="upload" :disabled="!participant_image" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showUploadCamera" persistent :max-width="$vuetify.breakpoint.height">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-2">
                      <v-flex xs12>
                        <vue-web-cam
                          ref="webcam"
                          :device-id="cameraDeviceId"
                          width="100%"
                          height="auto"
                          :resolution="{ width: 1920, height: 1080 }"
                          @cameras="cameraList"
                          @camera-change="cameraChange"
                        />
                      </v-flex>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUploadCamera" />
                      <action-button type="switchcamera" :icon="'fas fa-sync'" @click="cameraSwitch" />
                      <action-button type="upload" :icon="'camera_alt'" @click="cameraCapture" :text="$t('global.capture')" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showUploadDocumentForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("participants.upload_documents") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-4">
                      <ValidationObserver ref="files">
                        <v-flex xs12>
                          <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                            <v-file-input
                              v-model="files"
                              color="primary"
                              counter
                              multiple
                              :placeholder="$t('certificates.select_files')"
                              prepend-icon="attach_file"
                              outlined
                              :show-size="1000"
                              clearable
                              :error="errors.length > 0"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:selection="{ index, text }">
                                <v-chip color="primary" dark label small>
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </ValidationProvider>
                        </v-flex>
                      </ValidationObserver>
                      <v-flex xs12>
                        <v-card
                          @drop.prevent="documentOnDrop($event)"
                          @dragover.prevent="document_dragover = true"
                          @dragenter.prevent="document_dragover = true"
                          @dragleave.prevent="document_dragover = false"
                          :class="{ 'grey lighten-2': document_dragover }"
                        >
                          <v-card-text>
                            <v-row class="d-flex flex-column" dense align="center" justify="center">
                              <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                              <p>{{ $t("global.drop_files_here") }}</p>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          name="courses.description"
                          v-model="file_description"
                          :label="$t('courses.description')"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions class="mt-0 pt-0">
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUploadDocument" />
                      <action-button @click="uploadDocument()" type="upload" :disabled="files.length == 0" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showFileUpdate" persistent max-width="480px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("participants.update_document") }}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text class="pa-4 pb-0">
                      <v-flex xs12>
                        <v-text-field
                          v-model="computedFileName"
                          :label="$t('attendees.filename')"
                          :suffix="'.' + computedFileExtension"
                          required
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="computedFileDescription"
                          :label="$t('courses.description')"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions class="mt-0 pt-0">
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUpdateFile" />
                      <action-button @click="updateFile()" type="save" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showRemoveAttendeeModal" persistent max-width="480px">
          <div class="form-modal pa-4">
            <p>{{ $t("courses.move_attendee_message") }}</p>
            <action-button
              type="cancel"
              @click="moveAttendee('interested-list')"
              class="d-block mb-2"
              :icon="null"
              :text="$t('courses.move_attendee_interested_list')"
            />
            <action-button
              type="cancel"
              @click="moveAttendee('another-course')"
              class="d-block mb-2"
              :icon="null"
              :text="$t('courses.move_attendee_another_course')"
            />
            <action-button
              type="cancel"
              color="error"
              @click="removeAttendee(selectedAttendee)"
              class="d-block mb-2"
              :icon="null"
              :text="$t('courses.delete_attendee')"
            />
            <action-button type="cancel" color="error" @click="hideMoveAttendee" :icon="null" class="d-block" />
          </div>
        </v-dialog>

        <v-dialog v-model="showRemoveEnrolmentModal" persistent max-width="480px">
          <div class="form-modal pa-4">
            <p>
              {{
                selectedEnrolmentObj && selectedEnrolmentObj.status == 6
                  ? $t("fe.enrolment.delete_reservation")
                  : $t("courses.move_enrolment")
              }}
            </p>
            <action-button
              type="cancel"
              @click="moveEnrolment('interested-list')"
              class="d-block mb-2"
              :icon="null"
              :text="$t('courses.move_enrolment_interested_list')"
              v-if="selectedEnrolmentObj && selectedEnrolmentObj.status != 6"
            />
            <action-button
              type="cancel"
              @click="moveEnrolment('another-course')"
              class="d-block mb-2"
              :icon="null"
              :text="$t('courses.move_enrolment_another_course')"
              v-if="selectedEnrolmentObj && selectedEnrolmentObj.status != 6"
            />
            <action-button
              type="cancel"
              color="error"
              @click="delEnrolment(selectedEnrolment)"
              class="d-block mb-2"
              :icon="null"
              :text="$t('courses.delete_enrolment')"
            />
            <action-button type="cancel" color="error" @click="hideMoveEnrolment" :icon="null" class="d-block" />
          </div>
        </v-dialog>

        <v-dialog v-model="showCourseNotifDialog" persistent max-width="550px">
          <div class="form-modal pa-4">
            <p>{{ $t("courses.course_date_change_notification") }}</p>
            <p>
              <v-checkbox
                v-model="courseNotifEmail"
                :label="$t('notificationtemplates.email_notification')"
                dense
                :hide-details="true"
              ></v-checkbox>
              <v-checkbox
                v-model="courseNotifSMS"
                :label="$t('notificationtemplates.sms_notification')"
                dense
                :hide-details="true"
                :disabled="Boolean(!organisation.sms_service || !course.send_sms_notification)"
              ></v-checkbox>
            </p>
            <action-button type="save_and_send" @click="save(false, true)" />
            <action-button type="save_without_notification" @click="save(false, false)" />
            <action-button type="cancel" @click="cancelCourseNotifModal" />
          </div>
        </v-dialog>
      </v-container>
    </v-form>

    <participantListPopup
      :key="'plp-' + reRenderEnrVerify"
      :show="showParticipantListPopup"
      :except_ids="participantIds"
      :show_new_form_in_modal="true"
      from_module="course"
      @callback_partlistpopup_cancel="callback_partlistpopup_cancel"
      @callback_partlistpopup_submit="callback_partlistpopup_submit"
    />

    <participantListPopup
      :key="'pelp-' + reRenderEnrVerify"
      :show="showParticipantEnrolmentListPopup"
      :except_ids="participantEnrolmentIds"
      :show_new_form_in_modal="true"
      from_module="course"
      @callback_partlistpopup_cancel="callback_partenrlistpopup_cancel"
      @callback_partlistpopup_submit="callback_partenrlistpopup_submit"
    />

    <enrolmentListPopup
      :show="showEnrolmentListPopup"
      :statuses="[3]"
      :coursetype_id="course.coursetype_id"
      @callback_enrlistpopup_cancel="callback_enrlistpopup_cancel"
      @callback_enrlistpopup_submit="callback_enrlistpopup_submit"
    />

    <courseListPopup
      :title="$t('courses.title')"
      :show="showCourseListPopup"
      :except_ids="[course.id]"
      :coursetype_id="course.coursetype_id"
      :status_ids="[1]"
      :single_select="true"
      :show_course_filter="false"
      :show_coursetype_filter="true"
      @callback_courselistpopup_cancel="callback_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_courselistpopup_submit"
    />

    <courseListPopup
      :title="$t('courses.title')"
      :show="showAttendeeCourseListPopup"
      :except_ids="[course.id]"
      :coursetype_id="course.coursetype_id"
      :status_ids="[1]"
      :single_select="true"
      :show_course_filter="false"
      :show_coursetype_filter="true"
      @callback_courselistpopup_cancel="callback_attendee_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_attendee_courselistpopup_submit"
    />

    <enrolmentVerifyPopup
      :key="'env' + reRenderEnrVerify"
      :id="enrVerifiySelectedId"
      @callback_enrverify_merge="callback_enrverify_merge"
      @callback_enrverify_cancel="callback_enrverify_cancel"
      @callback_enrverify_postprocess="callback_enrverify_postprocess"
    />

    <moduleTemplateListPopup
      :show="showModuleTemplateListPopup"
      @callback_modtemplistpopup_cancel="callback_modtemplistpopup_cancel"
      @callback_modtemplistpopup_submit="callback_modtemplistpopup_submit"
    />

    <sendEmailTemplatePopup
      :show="showSendEmailTemplatePopup"
      :module="'course'"
      :module_id="course.id"
      :selected_ids="setpIds"
      :selected_ids_module="setpIdsModule"
      @callback_sendemailtemplatepopup_cancel="callback_sendemailtemplatepopup_cancel"
      @callback_sendemailtemplatepopup_send_success="callback_sendemailtemplatepopup_send_success"
      @callback_sendemailtemplatepopup_send_failed="callback_sendemailtemplatepopup_send_failed"
    />

    <silentUpdateAccomplishmentPopup
      v-if="showSUA"
      :key="'sua' + reRenderSua"
      :id="suaId"
      :silent_update="true"
      @callback_sua_update="callback_sua_update"
    />

    <preview-file :show="previewShowModal" :src="previewSrc" :filename="previewFilename" @callback_close_preview="callback_close_preview" />
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import attendeeCourseDetails from "../../attendees/partials/AttendeeCourse.vue"
import enrolmentDetails from "../../enrolments/partials/EnrolmentDetails.vue"
import participantListPopup from "../../participants/partials/ParticipantListPopup.vue"
import enrolmentListPopup from "../../enrolments/partials/EnrolmentListPopup.vue"
import courseListPopup from "../../courses/partials/CourseListPopup.vue"
import enrolmentVerifyPopup from "../../enrolments/partials/EnrolmentVerifyPopup.vue"
import moduleTemplateListPopup from "../../moduletemplates/partials/ModuleTemplateListPopup.vue"
import silentUpdateAccomplishmentPopup from "../../attendees/components/Accomplishment.vue"
import sendEmailTemplatePopup from "../../notificationtemplates/partials/SendEmailTemplatePopup.vue"
import draggable from "vuedraggable"
import { WebCam } from "vue-web-cam"

export default {
  name: "CourseForm",

  props: [
    "id",
    "modal",
    "start_date",
    "start_time",
    "end_date",
    "end_time",
    "coursetype_id",
    "coursetemplate_id",
    "from_module",
    "from_id"
  ],

  components: {
    ValidationObserver,
    ValidationProvider,
    "moduleoption-form": () => import("../../moduleoptions/components/Form"),
    "moduleoptioncoursetype-form": () => import("../../moduleoptioncoursetypes/components/Form"),
    "participant-form": () => import("../../participants/components/Form"),
    "coursemoduletemplate-form": () => import("../../coursemoduletemplates/components/Form"),
    "enrolment-basic-form": () => import("../../enrolments/components/FormBasic"),
    "address-form": () => import("../../addresses/components/Form"),
    sendEmailTemplatePopup,
    participantListPopup,
    enrolmentListPopup,
    attendeeCourseDetails,
    enrolmentDetails,
    courseListPopup,
    enrolmentVerifyPopup,
    silentUpdateAccomplishmentPopup,
    moduleTemplateListPopup,
    "vue-web-cam": WebCam,
    draggable,
    "preview-file": () => import("@/mixins/components/previewFile")
  },

  data() {
    return {
      page_title: "",

      predata: {},
      course: {},
      coursetemplate: {},

      organisation: {},
      companies: [],

      enrolment_form_link: "",
      showEnrolmentFormLinkCopiedToolTip: false,
      showInfoLinkCopiedToolTip: false,

      field_disabled: false,
      autoOpenEnrolment: null,

      showSUA: false,
      suaId: 0,
      reRenderSua: 0,
      hadAccomplishmentCompleted: null,

      showCourseNotifDialog: false,
      courseNotifEmail: false,
      courseNotifSMS: false,

      enrVerifiySelectedId: 0,
      reRenderEnrVerify: 0,

      expanded: [],
      expanded_enr: [],
      documents: [],

      selectedAttendees: [],
      selectedEnrolments: [],

      coursetypegroups: [],
      coursetypes: [],
      coursetemplates: [],
      classes: [],
      instructors: [],
      filteredInstructors: [],
      classrooms: [],
      addresses: [],
      number_of_days: 0,

      moduletemplates: [],

      course_times: [],
      predata_course_times: [],
      start_times_menu: [],
      end_times_menu: [],

      currentFormId: "",
      currentModuleTemplateId: "",
      currentModuleOptionId: "",
      currentCourseTemplateId: "",
      currentCourseTypes: [],
      currentCMTManuallyAdded: null,
      currentForm: "",
      currentFromModule: "course",
      showDialogForm: false,

      selectedParticipant: null,
      showUploadForm: false,
      participant_image: null,

      showModuleTemplateListPopup: false,
      showParticipantListPopup: false,
      participantIds: [],

      showSendEmailTemplatePopup: false,
      reRenderSendEmailTemplatePopup: 0,
      setpIds: [],
      setpIdsModule: null,

      showParticipantEnrolmentListPopup: false,
      participantEnrolmentIds: [],

      showEnrolmentListPopup: false,
      enrolmentIds: [],

      statuses: [],

      changes_notif: [],

      requestOnly: false,

      start_date_menu: false,
      start_time_menu: false,
      end_date_menu: false,
      end_time_menu: false,
      enr_due_date_menu: false,
      cert_issued_date_menu: false,
      cvu_date_menu: false,
      csd_dates_menu: [],
      csd_dates_format: [],

      search_attendees_params: {
        any: ""
      },

      attendees: [],
      attendee_total: 0,
      attendee_show_loading: false,
      attendee_show_filter: false,
      attendee_refresh: false,
      attendee_pagination: {
        page: this.$getLocalStorage("__courseAttendeeListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      enrolments: [],
      enr_ids: [],
      enr_total: 0,
      enr_show_loading: false,
      enr_refresh: false,
      enr_pagination: {
        page: this.$getLocalStorage("__courseEnrolmentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      notificationlogs: [],
      nl_ids: [],
      nl_total: 0,
      nl_show_loading: false,
      nl_refresh: false,
      nl_pagination: {
        page: this.$getLocalStorage("__courseNotificationLogListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: []
      },

      files: [],
      showUploadDocumentForm: false,
      showFileUpdate: false,
      file_description: null,
      selectedDocument: {},
      document_dragover: false,
      document_dragover_image: false,

      documents: [],
      dc_mode: null,
      dc_total_deleted: null,
      dc_title: this.$t("courses.course_documents"),
      dc_ids: [],
      dc_total: 0,
      dc_show_loading: false,
      dc_refresh: false,
      dc_pagination: {
        page: this.$getLocalStorage("__courseDocumentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      showRemoveEnrolmentModal: false,
      selectedEnrolment: null,

      showRemoveAttendeeModal: false,
      selectedAttendee: null,

      showCourseListPopup: false,
      showAttendeeCourseListPopup: false,

      integrations: [],
      integration_p360: null,
      integration_klarna: null,

      previewShowModal: null,
      previewSrc: null,
      previewFilename: null,

      dictionary: {
        attributes: {
          "course.name": this.$t("courses.name"),
          "course.description": this.$t("courses.description"),
          "course.short_description": this.$t("courses.short_description"),
          "course.coursetype_id": this.$t("coursetypes.title"),
          "course.coursetemplate_id": this.$t("coursetemplates.title"),
          //"course.class_id": this.$t("classes.title"),
          "course.instructor_id": this.$t("courses.instructor_id"),
          "course.address_id": this.$t("addresses.title"),
          "course.classroom_id": this.$t("classrooms.title"),
          "course.start_date": this.$t("courses.start_date"),
          "course.start_time": this.$t("courses.start_time"),
          "course.end_date": this.$t("courses.end_date"),
          "course.end_time": this.$t("courses.end_time"),
          //"course.location": this.$t("courses.location"),
          "course.num_places": this.$t("courses.num_places"),
          "course.status": this.$t("courses.status"),
          "course.is_published": this.$t("courses.is_published"),
          "course.exclude_weekends": this.$t("courses.exclude_weekends"),
          "course.enrolment_due_date": this.$t("courses.enrolment_due_date"),
          "course.certificate_issued_date": this.$t("courses.certificate_issued_date")
        }
      },

      uploadSelections: [
        { key: "file", label: this.$t("global.from_file") },
        { key: "camera", label: this.$t("global.from_camera") }
      ],

      showUploadCamera: false,
      cameraImg: null,
      camera: null,
      cameraDeviceId: null,
      cameraDevices: [],

      collapseExpand: undefined,
      collapseExpandIcon: "mdi-expand-all-outline",

      clpsCourseDateIcon: "mdi-expand-all-outline",
      clpsCourseDateExpand: undefined,

      clpsAttendeeIcon: "mdi-expand-all-outline",
      clpsAttendeeExpand: undefined,

      clpsEnrolmentIcon: "mdi-expand-all-outline",
      clpsEnrolmentExpand: undefined,

      clpsCourseDocumentIcon: "mdi-expand-all-outline",
      clpsCourseDocumentExpand: undefined,

      clpsCourseDescIcon: "mdi-expand-all-outline",
      clpsCourseDescExpand: undefined,

      clpsModuleTemplateIcon: "mdi-expand-all-outline",
      clpsModuleTemplateExpand: undefined,

      clpsNotificationLogIcon: "mdi-expand-all-outline",
      clpsNotificationLogExpand: undefined
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.course, this.predata, this.save, this.isFormValid)
    })
  },

  watch: {
    attendee_refresh: {
      handler() {
        if (this.attendee_refresh) {
          this.attendee_list()
        }
      }
    },
    attendee_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__courseAttendeeListPage", newVal.page)
          }

          this.attendee_refresh = true
        }
      }
    },
    enr_refresh: {
      handler() {
        if (this.enr_refresh) {
          this.enrolment_list()
        }
      }
    },
    enr_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__courseEnrolmentListPage", newVal.page)
          }

          this.enr_refresh = true
        }
      }
    },
    dc_refresh: {
      handler() {
        if (this.dc_refresh) {
          this.document_list()
        }
      }
    },
    dc_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__courseDocumentListPage", newVal.page)
          }

          this.dc_refresh = true
        }
      }
    },
    nl_refresh: {
      handler() {
        if (this.nl_refresh) {
          this.notificationlog_list()
        }
      }
    },
    nl_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__courseNotificationLogListPage", newVal.page)
          }

          this.nl_refresh = true
        }
      }
    },
    camera: function (id) {
      this.deviceId = id
    },
    clpsCourseDateExpand: {
      handler(newVal, oldVal) {
        this.clpsCourseDateIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsCourseDescExpand: {
      handler(newVal, oldVal) {
        this.clpsCourseDescIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsAttendeeExpand: {
      handler(newVal, oldVal) {
        this.clpsAttendeeIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsEnrolmentExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrolmentIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsNotificationLogExpand: {
      handler(newVal, oldVal) {
        this.clpsNotificationLogIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsModuleTemplateExpand: {
      handler(newVal, oldVal) {
        this.clpsModuleTemplateIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  computed: {
    cameraDevice: function () {
      return this.cameraDevices.find((n) => n.deviceId === this.cameraDeviceId)
    },
    isAdmin() {
      return this.$hasRole("system-developer") || this.$hasRole("organisation-admin")
    },
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    attendee_headers: {
      get() {
        let headers = [
          { text: "", value: "data-table-expand" },
          { text: this.$t("attendees.student_name"), value: "student_name" },
          { text: this.$t("enrolments.p_company"), value: "company" },
          { text: this.$t("attendees.image"), value: "image_updated_at", width: "10%" },
          { text: this.$t("enrolments.p_date_of_birth"), value: "date_of_birth" },
          { text: this.$t("attendees.accomplishment"), value: "accomplishment_total", sortable: false },
          { text: this.$t("attendees.met_up_days"), value: "met_up_days", sortable: false, display: false },
          { text: this.$t("attendees.certificate_chk"), value: "release_certificate", width: "5%", sortable: false },
          { text: this.$t("attendees.course_certificate"), value: "certificate", width: "10%", sortable: false },
          { text: this.$t("integrations.p360"), value: "p360", width: "10%", sortable: false },
          { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end", sortable: false }
        ]

        if (!this.integration_p360) {
          headers = headers.filter((i) => i.value != "p360")
        }

        if (this.coursetemplate.type == 2) {
          // 2 - Long Course
          headers = headers.filter((i) => i.value != "met_up_days")
        }

        return headers
      }
    },
    enr_headers: {
      get() {
        return [
          { text: "", value: "data-table-expand" },
          { text: this.$t("enrolments.name"), value: "name" },
          { text: this.$t("enrolments.p_company"), value: "company" },
          { text: this.$t("enrolments.p_email"), value: "email" },
          { text: this.$t("enrolments.p_mobile"), value: "mobile" },
          { text: this.$t("enrolments.p_date_of_birth"), value: "date_of_birth" },
          { text: this.$t("enrolments.enrolled"), value: "created_at" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    dc_headers: {
      get() {
        let headers = [
          { text: this.$t("certificates.filename"), value: "original_filename" },
          { text: this.$t("courses.description"), value: "description" },
          { text: this.$t("certificates.size"), value: "size" },
          { text: this.$t("certificates.created_at"), value: "created_at" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]

        if (this.dc_mode == "deleted") {
          headers = [
            { text: this.$t("certificates.filename"), value: "original_filename" },
            { text: this.$t("courses.description"), value: "description" },
            { text: this.$t("certificates.size"), value: "size" },
            { text: this.$t("certificates.deleted_on"), value: "deleted_at" },
            { text: this.$t("certificates.removed_on"), value: "deleted_on" },
            { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
          ]
        }

        return headers
      }
    },
    nl_headers: {
      get() {
        return [
          { text: this.$t("notificationlogs.type"), value: "type", width: "90px" },
          { text: this.$t("notificationlogs.date_sent"), value: "date_sent" },
          { text: this.$t("notificationlogs.recipient"), value: "recipient" },
          { text: this.$t("notificationlogs.subject"), value: "subject" },
          { text: this.$t("notificationlogs.sender"), value: "sender_name" },
          { text: this.$t("notificationlogs.status"), value: "status" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    fieldDisabled() {
      let disabled = Boolean(this.course.coursetype_id && this.course.coursetemplate_id) === true ? false : true

      if (this.$hasRole("system-developer") || (this.$hasRole("organisation-admin") && this.$can("course-edit"))) {
        disabled = false
      } else {
        // If logged in user is an instructor and the course is assigned to another instructor
        if (
          this.user &&
          this.user.is_instructor &&
          this.course.id &&
          this.predata.instructor_id &&
          this.predata.instructor_id != this.user.id
        ) {
          disabled = true
        }

        // If course status "5 = Ongoing" disable field
        if (this.course.id && this.predata.status == 5 && this.user && !this.user.is_instructor) {
          // 5 = Ongoing
          disabled = true
        }
      }

      return disabled
    },
    computedCourseStartDate: {
      get() {
        return this.$dateFormatGetter(this.course.start_date)
      },
      set(val) {
        this.$set(this.course, "start_date", this.$dateFormatSetter(val))
      }
    },
    computedCourseStartTime: {
      get() {
        return this.$timeFormatGetter(this.course.start_time)
      },
      set(val) {
        this.$set(this.course, "start_time", this.$timeFormatSetter(val))
      }
    },
    computedCourseEndDate: {
      get() {
        return this.$dateFormatGetter(this.course.end_date)
      },
      set(val) {
        this.$set(this.course, "end_date", this.$dateFormatSetter(val))
      }
    },
    computedCourseEndTime: {
      get() {
        return this.$timeFormatGetter(this.course.end_time)
      },
      set(val) {
        this.$set(this.course, "end_time", this.$timeFormatSetter(val))
      }
    },
    computedEnrDueDate: {
      get() {
        return this.$dateFormatGetter(this.course.enrolment_due_date)
      },
      set(val) {
        this.$set(this.course, "enrolment_due_date", this.$dateFormatSetter(val))
      }
    },
    computedCertValidUntil: {
      get() {
        return this.$dateFormatGetter(this.course.certificate_valid_until)
      },
      set(val) {
        this.$set(this.course, "certificate_valid_until", this.$dateFormatSetter(val))
      }
    },
    computedCertIssuedDate: {
      get() {
        return this.$dateFormatGetter(this.course.certificate_issued_date)
      },
      set(val) {
        this.$set(this.course, "certificate_issued_date", this.$dateFormatSetter(val))
      }
    },
    computedFileName: {
      get() {
        return this.$getFileName(this.selectedDocument.original_filename)
      },
      set(val) {
        this.$set(
          this.selectedDocument,
          "new_original_filename",
          val + "." + this.$getFileExtension(this.selectedDocument.original_filename)
        )
      }
    },
    computedFileExtension: {
      get() {
        return this.$getFileExtension(this.selectedDocument.original_filename)
      }
    },
    computedFileDescription: {
      get() {
        return this.selectedDocument.description
      },
      set(val) {
        this.$set(this.selectedDocument, "new_description", val)
      }
    },
    currentLoadedForm: function () {
      let form,
        id,
        coursetypes,
        moduletemplate_id,
        moduleoption_id,
        select_visibility,
        disable_accomp_select,
        disable_enrol_select = null

      let selModTemp = this.moduletemplates.find((i) => i.id == this.currentModuleTemplateId)

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
        coursetypes = this.currentCourseTypes
        moduletemplate_id = this.currentModuleTemplateId
        moduleoption_id = this.currentModuleOptionId
        ;(select_visibility = selModTemp ? selModTemp.select_visibility : null),
          (disable_accomp_select = selModTemp ? Boolean(selModTemp.hide_in_accomplishment) : false)
        disable_enrol_select = selModTemp ? Boolean(selModTemp.hide_in_enrolment) : false
      }

      return {
        id: id,
        form: form,
        moduletemplate_id: moduletemplate_id,
        moduleoption_id: moduleoption_id,
        coursetypes: coursetypes,
        select_visibility: select_visibility,
        disable_accomp_select: disable_accomp_select,
        disable_enrol_select: disable_enrol_select
      }
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.course.price)
      },
      set(val) {
        this.$set(this.course, "price", this.$priceFormatSetter(val))
      }
    },
    cmDragged: {
      get() {
        return this.moduletemplates
      },
      set(list) {
        if (list) {
          var data = []
          var ctr = 1

          list.forEach((item, index) => {
            item.order = ctr

            data.push({ id: item.id, order: item.order })

            ctr++
          })

          axios
            .put(this.API_URL + "course/moduletemplateorder", {
              data: data
            })
            .then((res) => {
              this.moduletemplates = list
            })
            .catch((err) => console.log(err))
        }
      }
    },
    selectedEnrolmentObj() {
      let obj = this.enrolments.find((i) => i.id == this.selectedEnrolment)
      return obj
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.autoOpenEnrolment = this.$route.query.autoOpenEnrolment
    this.statuses = this.$dd_course_status()

    let path = this.$router.currentRoute.path

    // Load organisation
    axios
      .get(this.API_URL + "organisation/my?resourcetype=basic")
      .then((res) => {
        this.$store.dispatch("master/setAxiosHideLoader", true)
        this.organisation = res.data.data
        this.integrations = this.organisation.integrations

        if (this.integrations) {
          this.integration_p360 = this.integrations.find((i) => i.slug == this.INTEGRATION_SLUG_P360)
          this.integration_klarna = this.integrations.find((i) => i.slug == this.INTEGRATION_SLUG_KLARNA)
        }

        if (!this.id) {
          this.course = {
            status: 5,
            //start_date: this.start_date
            // ? this.moment.utc(this.start_date).format(this.MYSQL_DATE_FORMAT)
            // : this.moment().format(this.MYSQL_DATE_FORMAT),
            //start_time: this.start_time ? this.start_time : this.moment.utc("08:00:00", this.TIME_FORMAT).format(this.MYSQL_TIME_FORMAT),
            //end_date: this.end_date ? this.moment.utc(this.end_date) : this.moment().format(this.MYSQL_DATE_FORMAT),
            //end_time: this.end_time ? this.end_time : this.moment.utc("16:00:00", this.TIME_FORMAT).format(this.MYSQL_TIME_FORMAT),
            //enrolment_due_date: this.enrolment_due_date
            // ? this.moment.utc(this.enrolment_due_date).format(this.MYSQL_DATE_FORMAT)
            //: this.moment().format(this.MYSQL_DATE_FORMAT),
            number_of_days: 1,
            klarna_checkout_type: this.integration_klarna ? this.$getDefaultDropdown(this.$dd_klarna_checkout_type()) : null
          }

          if (path == "/app/courses/longrun/create") {
            this.coursetemplate.type = 2
          }

          if (this.from_module == "enrolment-organisation" && this.from_id) {
            this.course.company_id = this.from_id
          }

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.course))

          this.setPageTitle()
          this.ddlist()

          if (this.coursetemplate_id && this.coursetype_id) {
            this.$set(this.course, "coursetype_id", Number(this.coursetype_id))
            this.$set(this.course, "coursetemplate_id", Number(this.coursetemplate_id))
            this.courseTemplateChange()
          }
        } else {
          this.title = this.$t("courses.update_title")
          this.$store.dispatch("master/setAxiosHideLoader", true)

          axios
            .get(this.API_URL + "course/" + this.id)
            .then((res) => {
              this.course = res.data.data
              this.coursetemplate = this.course.coursetemplate
              this.number_of_days = this.course.number_of_days > 0 ? this.course.number_of_days : 1
              this.currentCourseTypes = this.course.coursetemplate.coursetypes
                ? this.course.coursetemplate.coursetypes.map((a) => a.id)
                : []

              this.moduletemplates = this.course.moduletemplates
              this.setCourseInfoLink()

              if (this.from_module == "enrolment-organisation" && this.from_id) {
                this.course.company_id = this.from_id
              }

              if (!this.organisation.sms_service) {
                this.course.send_sms_notification = 0
              }

              if (this.integration_klarna && !this.course.klarna_checkout_type) {
                this.course.klarna_checkout_type = this.$getDefaultDropdown(this.$dd_klarna_checkout_type())
              }

              this.setPageTitle()
              this.ddlist()
              this.attendee_refresh = true
              this.enr_refresh = true

              // Check if long course
              if (this.coursetemplate && this.coursetemplate.type == 2) {
                // 2 = Long course
                this.clpsAttendeeExpand = undefined
                this.clpsEnrolmentExpand = undefined
              }

              // Check start date (4 set of codes)
              if (this.course.start_date) {
                let today = this.moment()
                let course_start = this.moment(this.course.start_date)
                let result = course_start.isAfter(today)

                if (!result) {
                  this.statuses = this.$dd_course_status().filter((i) => i.key != 1) // 1 = Upcoming
                  if (this.course.status == 1) {
                    this.course.status = null
                  }
                } else {
                  this.statuses = this.$dd_course_status()
                }
              }

              // JSON stringify and parse to remove variable reactiveness
              this.predata = JSON.parse(JSON.stringify(this.course))

              this.initCourseStartEndTime()
            })
            .catch((err) => console.log(err))
        }
      })
      .catch((err) => console.log(err))
  },

  methods: {
    setPageTitle() {
      if (_.has(this.course, "id")) {
        this.page_title = this.course.id + " " + this.course.name
      } else {
        if (this.coursetemplate.type == 2) {
          this.page_title = this.$t("courses.new_longrun_course")
        } else {
          this.page_title = this.$t("courses.new_course")
        }
      }
    },
    ddlist() {
      let query_ct = this.course.coursetype_id ? "&query_course_type_id=" + this.course.coursetype_id : ""

      if (this.coursetemplate.type == 2) {
        query_ct += "&query_type=2" // Long run
      }

      let lists = [
        { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true&resourcetype=coursetypegroup-ddlist" },
        { key: "coursetypes", module: "coursetypes", query: "show_all=true" },
        //{ key: 'classes', module: 'classes', query: "show_all=true", },
        { key: "addresses", module: "addresses", query: "show_all=true" },
        { key: "instructors", module: "users", query: "show_all=true&query_is_instructor=1&query_status=1" },
        {
          key: "coursetemplates",
          module: "coursetemplates",
          query: "show_all=true&resourcetype=coursetemplate-ddlist&query_status=1" + query_ct + "&sort_by=name&sort_order=asc"
        },
        { key: "classrooms", module: "classrooms", query: "show_all=true&query_address_id=" + this.course.address_id },
        { key: "companies", module: "enrolled_organisations", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.coursetypes = res.data.coursetypes
        //this.classes = res.data.classes;
        this.addresses = res.data.addresses
        this.instructors = res.data.instructors
        this.coursetemplates = res.data.coursetemplates
        this.classrooms = res.data.classrooms
        this.companies = res.data.companies

        if (this.addresses.length == 1) {
          this.course.address_id = this.addresses[0].id
        }

        this.filterInstructorCourseType()
      })
    },
    setCourseInfoLink() {
      if (this.course.id) {
        this.enrolment_form_link =
          "https://" + window.location.host + "/f/no/enrolment/template/" + this.coursetemplate.uuid + "/course/" + this.course.uuid
        if (this.course.company_id) {
          this.enrolment_form_link = "https://" + window.location.host + "/f/no/enrolment/organisation/course/" + this.course.uuid
        }
      }
    },
    filterInstructorCourseType() {
      if (this.instructors) {
        this.filteredInstructors = this.instructors.filter((i) => i.ct_ids.includes(this.course.coursetype_id))
      }
    },
    attendee_list() {
      this.attendee_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.attendee_pagination
      let query = this.$queryString(this.attendee_pagination, {
        ...this.search_attendees_params,
        course_id: this.course.id,
        tenant_user_status: 1
      })

      axios.get(this.API_URL + "attendees?resourcetype=attendee-course&" + query).then((res) => {
        this.attendees = res.data.data
        this.attendee_total = res.data.meta.total
        this.attendee_refresh = false
        this.attendee_show_loading = false

        this.participantIds = this.attendees.map((a) => a.participant_id)

        this.attendee_pagination.page = res.data.meta.current_page
        this.attendee_pagination.itemsPerPage = Number(res.data.meta.per_page)

        let completed = this.attendees.filter((i) => i.accomplishment_total == 100 && i.certificate_filename)
        this.hadAccomplishmentCompleted = completed.length > 0 ? true : false
      })
    },
    enrolment_list() {
      if (this.course.id) {
        this.enr_show_loading = true

        let ids = this.enr_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.enr_pagination
        let query = this.$queryString(this.enr_pagination, { course_id: this.course.id, statuses: "1,2,6" })

        axios
          .get(this.API_URL + "enrolments" + "?" + query)
          .then((res) => {
            this.enrolments = res.data.data
            this.enr_total = res.data.meta.total
            this.enr_refresh = false
            this.enr_show_loading = false

            this.enr_pagination.page = res.data.meta.current_page
            this.enr_pagination.itemsPerPage = Number(res.data.meta.per_page)

            // auto open enrolment row
            if (this.autoOpenEnrolment) {
              var rowid = "enr-row-" + this.autoOpenEnrolment
              this.expanded_enr.push(this.enrolments.find((i) => i.id == this.autoOpenEnrolment))

              if (document.getElementById(rowid)) {
                this.$vuetify.goTo("#" + rowid)
              }
            }
          })
          .catch((err) => console.log(err))
      }
    },
    document_list() {
      if (this.course.id) {
        this.dc_show_loading = true

        let ids = this.dc_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.dc_pagination
        let query = this.$queryString(this.dc_pagination, { course_id: this.course.id })

        axios
          .get(this.API_URL + "course/documents" + "?mode=" + this.dc_mode + "&" + query)
          .then((res) => {
            this.documents = res.data.data
            this.dc_total = res.data.meta.total
            this.dc_total_deleted = res.data.total_deleted
            this.dc_refresh = false
            this.dc_show_loading = false

            this.dc_pagination.page = res.data.meta.current_page
            this.dc_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    toggleDocumentList() {
      if (this.dc_mode == null) {
        this.dc_mode = "deleted"
        this.dc_show_select = false
        this.dc_title = this.$t("courses.course_documents") + " " + this.$t("participants.deleted_documents")
      } else {
        this.dc_mode = null
        this.dc_show_select = true
        this.dc_title = this.$t("courses.course_documents")
      }
      this.document_list()
    },
    notificationlog_list() {
      if (this.course.id) {
        this.nl_show_loading = true

        let ids = this.nl_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.nl_pagination
        let query = this.$queryString(this.nl_pagination, { parent_module: "course", parent_id: this.course.id })

        axios
          .get(this.API_URL + "notificationlogs" + "?" + query)
          .then((res) => {
            this.notificationlogs = res.data.data
            this.nl_total = res.data.meta.total
            this.nl_refresh = false
            this.nl_show_loading = false

            this.nl_pagination.page = res.data.meta.current_page
            this.nl_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    filterAttendees(target) {
      this.attendee_refresh = true
    },
    initCourseStartEndTime(force_change = false) {
      this.course_times = []
      this.csd_dates_menu = []

      if (this.course.start_date && this.course.start_time && this.course.end_date && this.course.end_time) {
        let time_per_day = this.course.time_per_day
        let start = this.moment(this.course.start_date, this.MYSQL_DATE_FORMAT)
        let end = this.moment(this.course.end_date, this.MYSQL_DATE_FORMAT)
        let number_of_days = end.diff(start, "days") + 1

        if (number_of_days > 0) {
          if (this.course.adjust_time_per_day && time_per_day && !force_change) {
            for (const [index, row] of Object.entries(time_per_day)) {
              this.course_times.push({
                index: index,
                date: row.date,
                date_format: this.$dateFormatGetter(row.date),
                start_time: row.start_time,
                end_time: row.end_time
              })
              this.csd_dates_menu.push(false)
            }
          } else {
            for (let i = 1; i <= number_of_days; i++) {
              let date = null
              let start_time = this.$timeFormatGetter(this.course.start_time)
              let end_time = this.$timeFormatGetter(this.course.end_time)

              if (i == 1) {
                date = this.course.start_date // add the course start date
              } else if (i == number_of_days) {
                date = this.course.end_date // add the course end date
              } else {
                date = start.add(1, "days").format(this.MYSQL_DATE_FORMAT)
              }

              let momentDate = this.moment(date)
              if (this.course.exclude_weekends && (momentDate.day() === 6 || momentDate.day() === 0)) {
                // 6 = Saturday, 0 = Sunday
                continue
              }

              this.course_times.push({
                index: i - 1,
                date: date,
                date_format: this.$dateFormatGetter(date),
                start_time: start_time,
                end_time: end_time
              })
              this.csd_dates_menu.push(false)
            }
          }

          this.predata_course_times = JSON.parse(JSON.stringify(this.course_times))
        }
      }
    },
    preSaveCourseStartEndTime() {
      let data = []

      if (this.course.adjust_time_per_day) {
        this.course_times.forEach((item) => {
          item.date = this.$dateFormatSetter(item.date)
          item.start_time = this.$timeFormatSetter(item.start_time)
          item.end_time = this.$timeFormatSetter(item.end_time)
          data.push(item)
        })
      }

      return data
    },
    adjustTimePerDayChange() {
      let value = this.adjust_time_per_day

      if (!value) {
        // check if the start/end time are changed
        let bool = false
        this.course_times.forEach((item) => {
          if (
            item.start_time != this.$timeFormatGetter(this.course.start_time) ||
            item.end_time != this.$timeFormatGetter(this.course.end_time)
          ) {
            bool = true
          }
        })

        if (bool) {
          this.$awn.confirm(
            this.$t("courses.adjust_time_per_day_confirm"),
            () => {
              this.course.time_per_day = null
              this.initCourseStartEndTime(true)
              this.updateNumberOfDays()
            },
            () => {
              this.$set(this.course, "adjust_time_per_day", !value)
            },
            {
              labels: {
                confirmOk: this.$t("global.yes"),
                confirmCancel: this.$t("global.no")
              }
            }
          )
        } else {
          this.course.time_per_day = null
          this.initCourseStartEndTime(true)
          this.updateNumberOfDays()
        }
      }
    },
    csdTextChange(idx) {
      this.$set(this.course_times[idx], "date", this.$dateFormatSetter(this.course_times[idx].date_format))

      if (idx == 0) {
        let obj = this.course_times[idx]
        if (obj) {
          this.$set(this.course, "start_date", this.$dateFormatSetter(obj.date))
        }
      }

      if (idx == this.course.number_of_days - 1) {
        let obj = this.course_times[idx]
        if (obj) {
          this.$set(this.course, "end_date", this.$dateFormatSetter(obj.date))
        }
      }
    },
    csdChange(idx) {
      this.$set(this.course_times[idx], "date_format", this.$dateFormatGetter(this.course_times[idx].date))

      if (idx == 0) {
        let obj = this.course_times[idx]
        if (obj) {
          this.$set(this.course, "start_date", this.$dateFormatSetter(obj.date))
        }
      }

      if (idx == this.course.number_of_days - 1) {
        let obj = this.course_times[idx]
        if (obj) {
          this.$set(this.course, "end_date", this.$dateFormatSetter(obj.date))
        }
      }

      this.$validator.validate(this.$t("drivingtests.date") + " [" + (idx + 1) + "]", this.course_times[idx].date_format)
    },
    startTimeChange(idx) {
      // if the first start time is changed, adjust the course.start_time
      if (idx == 0) {
        let obj = this.course_times[idx]
        if (obj) {
          this.$set(this.course, "start_time", this.$timeFormatSetter(obj.start_time))
        }
      }
    },
    endTimeChange(idx) {
      // if the last end time is changed, adjust the course.start_time
      if (idx == this.course.number_of_days - 1) {
        let obj = this.course_times[idx]
        if (obj) {
          this.$set(this.course, "end_time", this.$timeFormatSetter(obj.end_time))
        }
      }
    },
    convert(id) {
      let vm = this

      axios
        .post(this.API_URL + "participant/convert", {
          id: id
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              vm.$awn.success(vm.$t("enrolments.add_to_participant_success"))
            } else {
              vm.$awn.alert(vm.$t("enrolments.add_to_participant_error"))
            }

            vm.enr_refresh = true
            vm.attendee_refresh = true
          }
        })
        .catch((err) => {
          if (err.response.status == 451) {
            vm.$awn.alert(vm.$t("enrolments.already_enrolled"))
            vm.enr_refresh = true
            vm.attendee_refresh = true
          }
        })
    },
    showMoveEnrolment(id) {
      this.selectedEnrolment = id
      this.showRemoveEnrolmentModal = true
    },
    hideMoveEnrolment() {
      this.selectedEnrolment = null
      this.selectedEnrolments = []
      this.showRemoveEnrolmentModal = false
    },
    moveEnrolment(type) {
      let vm = this

      if (type == "interested-list") {
        let enrolment = this.enrolments.find((i) => i.id == this.selectedEnrolment)

        if (enrolment) {
          axios
            .post(this.API_URL + "enrolment/moved-interestedlist", {
              id: this.selectedEnrolment,
              course_id: this.course.id
            })
            .then((res) => {
              vm.$awn.success(vm.$t("courses.move_enrolment_interested_list_success"))
              vm.hideMoveEnrolment()
              vm.enr_refresh = true
            })
            .catch((err) => {
              vm.$awn.alert(vm.$t("courses.move_enrolment_interested_list_failed"))
              vm.hideMoveEnrolment()
              vm.enr_refresh = true
            })
        } else {
          vm.hideMoveEnrolment()
        }
      }

      if (type == "another-course") {
        this.courselistpopup_show()
      }
    },
    callback_enrverify_show(id) {
      this.enrVerifiySelectedId = id
      this.reRenderEnrVerify++
    },
    callback_enrverify_merge(bool) {
      if (bool) {
        this.enr_refresh = true
        this.attendee_refresh = true
      }
    },
    callback_enrverify_cancel() {
      this.enr_refresh = true
      this.enrVerifiySelectedId = 0
    },
    callback_enrverify_postprocess() {
      this.convert(this.enrVerifiySelectedId)
    },
    /*callback_has_match(bool, id) {
            let vm = this;

            if (!bool) {
                this.$awn.confirm(
                    this.$t("enrolments.convert_to_participant_message"),
                    () => {
                        //this.convert(id);
                    },
                    () => {
                        this.enrVerifiySelectedId = 0;
                        return;
                    }
                );
            }
        },*/
    loadModuleTemplates() {
      let vm = this

      axios
        .get(this.API_URL + "course/" + this.course.id)
        .then((res) => {
          vm.moduletemplates = res.data.data.moduletemplates
        })
        .catch((err) => console.log(err))
    },
    startDateTimeChange() {
      // Check start date (4 set of codes)
      if (this.course.start_date && !this.course.start_time) {
        let today = this.moment()
        let course_start = this.moment(this.course.start_date)
        let result = course_start.isAfter(today)

        if (!result) {
          this.statuses = this.$dd_course_status().filter((i) => i.key != 1) // 1 = Upcoming
          if (this.course.status == 1) {
            this.course.status = null
          }
        } else {
          this.statuses = this.$dd_course_status()
        }
      }

      // Check start date (4 set of codes)
      if (this.course.start_date && this.course.start_time) {
        let today = this.moment()
        let course_start = this.moment(this.course.start_date + " " + this.course.start_time)
        let result = course_start.isAfter(today)

        if (result) {
          this.course.status = 1 // Upcoming
          this.statuses = this.$dd_course_status()
        } else {
          this.course.status = 5 // On Going
          this.statuses = this.$dd_course_status().filter((i) => i.key != 1) // 1 = Upcoming
        }
      }

      if (this.course.start_date) {
        if (this.coursetemplate.enrolment_due_in_days) {
          let ed_start = this.moment(this.course.start_date)
          let ed = ed_start.subtract(this.coursetemplate.enrolment_due_in_days - 1, "days")

          this.$set(this.course, "enrolment_due_date", this.moment(ed).format(this.MYSQL_DATE_FORMAT))
        } else {
          this.$set(this.course, "enrolment_due_date", this.course.start_date)
        }
      }

      if (this.course.start_date && this.course.start_time) {
        let no_of_days = this.course.number_of_days || 1
        no_of_days = no_of_days - 1

        let course_start = this.moment(this.course.start_date + " " + this.course.start_time)
        let course_end = course_start.add(no_of_days, "days")

        this.$set(this.course, "end_date", this.$dateFormatSetter(this.moment(course_end, this.MYSQL_DATE_FORMAT)))
      }

      this.updateNumberOfDays()
      this.initCourseStartEndTime(true)
    },
    endDateTimeChange() {
      let vm = this

      if (this.course.start_date && this.course.start_time && this.course.end_date && this.course.end_time) {
        let course_start = this.moment(this.course.start_date + " " + this.course.start_time)
        let course_end = this.moment(this.course.end_date + " " + this.course.end_time)

        if (course_start > course_end) {
          this.course.end_date = JSON.parse(JSON.stringify(this.course.start_date))
          //this.course.end_time = JSON.parse(JSON.stringify(this.course.start_time));
        }

        this.$set(this.course, "certificate_issued_date", this.course.end_date)

        if (this.coursetemplate.valid_for) {
          let end = vm.course.end_date ? vm.moment(vm.course.end_date, vm.MYSQL_DATE_FORMAT) : vm.moment()
          let cert_valid_until = end.add(this.coursetemplate.valid_for, "months").add(1, "days")
          vm.$set(vm.course, "certificate_valid_until", cert_valid_until.format(vm.MYSQL_DATE_FORMAT))
        }

        this.updateNumberOfDays()
        this.initCourseStartEndTime(true)
      }

      if (this.course.start_date && this.course.end_date) {
        this.updateNumberOfDays()
      }
    },
    updateNumberOfDays() {
      if (this.course.start_date && this.course.end_date) {
        let start = this.moment(this.course.start_date, this.MYSQL_DATE_FORMAT)
        let end = this.moment(this.course.end_date, this.MYSQL_DATE_FORMAT)
        let number_of_days = end.diff(start, "days")

        if (this.course.exclude_weekends) {
          for (var m = start; m.diff(end, "days") <= 0; m.add(1, "days")) {
            var day = m.day()
            var isWeekend = day === 6 || day === 0 // 6 = Saturday, 0 = Sunday

            if (isWeekend) number_of_days--
          }
        }

        if (number_of_days > 0) {
          number_of_days = number_of_days + 1
          this.$set(this.course, "number_of_days", number_of_days)
        } else {
          this.$set(this.course, "number_of_days", 1)
        }

        if (this.course.number_of_days < 31) {
          this.$set(this.course, "register_attendance", 1)
        } else {
          this.$set(this.course, "register_attendance", 0)
        }

        this.initCourseStartEndTime(true)
      }
    },
    cancel(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("courses.cancelcourse_message"),
        () => {
          axios
            .put(vm.API_URL + "course/cancel/" + id)
            .then((res) => {
              vm.predata = JSON.parse(JSON.stringify(vm.course))
              vm.$router.push(this.BACKEND_URL + "/courses")
              vm.$awn.success(vm.$t("courses.cancelcourse_success"))
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "course/" + id)
            .then((res) => {
              if (this.coursetemplate.type == 2) {
                vm.$router.push(this.BACKEND_URL + "/courses/longrun")
              } else {
                vm.$router.push(this.BACKEND_URL + "/courses")
              }

              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursemoduleoption/" + id)
            .then((res) => {
              vm.loadModuleTemplates()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option_ct(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursemoduleoptioncoursetype/" + id)
            .then((res) => {
              vm.loadModuleTemplates()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    showForm(id, type, mid, cid) {
      this.currentFormId = id

      if (type == "moduleoption") this.currentModuleTemplateId = mid
      if (type == "moduleoptioncoursetype") this.currentModuleOptionId = mid
      if (type == "coursemoduletemplate") {
        this.currentCMTManuallyAdded = mid
      }

      this.currentCourseTemplateId = cid

      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      if (data.hasOwnProperty("updateaccomplishment") && data.updateaccomplishment) {
        this.silentUpdateAccomplishment()
      } else {
        // Check if the modal is from other module
        if (data && data.module == "addresses" && data.data && data.data.id) {
          this.addresses.push(data.data)
          this.course.address_id = data.data.id
        } else {
          this.loadModuleTemplates()
        }

        this.return_modal_cancel_form()
      }
    },
    return_modal_cancel_form() {
      if (this.currentForm == "enrolment-basic-form") {
        this.enr_refresh = true
        this.expanded_enr = []
      }

      this.currentForm = ""
      this.currentCourseTemplateId = ""
      this.currentModuleTemplateId = ""
      this.currentModuleOptionId = ""
      this.currentCMTManuallyAdded = null
      this.suaId = 0
      this.showSUA = false
      this.showDialogForm = false
    },
    showCourseNotifModal() {
      this.showCourseNotifDialog = true
      this.courseNotifEmail = false
      this.courseNotifSMS = false
    },
    cancelCourseNotifModal() {
      this.showCourseNotifDialog = false
      this.courseNotifEmail = false
      this.courseNotifSMS = false
      this.changes_notif = []
    },
    save(checkCourseDataChange = true, sendNotification = false) {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.course.id) {
              if (
                this.coursetemplate.type == 1 &&
                (!this.course.start_date || !this.course.start_time || !this.course.end_date || !this.course.end_time)
              ) {
                this.$awn.alert(this.$t("courses.dates_not_set"))
                return
              }

              // Create
              axios
                .post(this.API_URL + "course", {
                  name: this.course.name,
                  short_description: this.course.short_description,
                  description: this.course.description,
                  certificate_display_name: this.course.certificate_display_name,
                  coursetypegroup_id: this.course.coursetypegroup_id,
                  coursetype_id: this.course.coursetype_id,
                  coursetemplate_id: this.course.coursetemplate_id,
                  //class_id: this.course.class_id,
                  instructor_id: this.course.instructor_id,
                  stand_in: this.course.stand_in,
                  classroom_id: this.course.classroom_id,
                  address_id: this.course.address_id,
                  company_id: this.course.company_id,
                  start_date: this.course.start_date,
                  start_time: this.course.start_time,
                  end_date: this.course.end_date,
                  end_time: this.course.end_time,
                  enrolment_due_date: this.course.enrolment_due_date,
                  certificate_valid_until: this.course.certificate_valid_until,
                  certificate_issued_date: this.course.certificate_issued_date,
                  price: this.course.price,
                  //location: this.course.location,
                  num_places: this.course.num_places,
                  number_of_days: this.course.number_of_days,
                  exclude_weekends: this.course.exclude_weekends,
                  register_attendance: this.course.register_attendance,
                  adjust_time_per_day: this.course.adjust_time_per_day,
                  time_per_day: this.preSaveCourseStartEndTime(),
                  send_email_notification: this.course.send_email_notification,
                  send_sms_notification: this.organisation.sms_service ? this.course.send_sms_notification : 0,
                  klarna_checkout: this.integration_klarna ? this.course.klarna_checkout : null,
                  klarna_checkout_type: this.integration_klarna && this.course.klarna_checkout ? this.course.klarna_checkout_type : null,
                  status: this.course.status,
                  is_published: this.course.is_published,
                  allow_overbook: this.course.allow_overbook,
                  allow_reservation: this.course.allow_reservation,
                  changes_notif: null,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.course = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.course))

                      vm.coursetemplate = vm.course.coursetemplate
                      vm.number_of_days = vm.course.number_of_days > 0 ? vm.course.number_of_days : 1
                      vm.currentCourseTypes = vm.course.coursetemplate.coursetypes
                        ? vm.course.coursetemplate.coursetypes.map((a) => a.id)
                        : []
                      vm.moduletemplates = vm.course.moduletemplates
                      vm.setCourseInfoLink()
                      vm.initCourseStartEndTime()

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "course",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.setPageTitle()

                        if (this.coursetemplate.type == 2) {
                          vm.$router.replace(this.BACKEND_URL + `/courses/longrun/edit/${vm.course.id}`).catch(() => {})
                        } else {
                          vm.$router.replace(this.BACKEND_URL + `/courses/edit/${vm.course.id}`).catch(() => {})
                        }
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              // check if the course start/end date/time is change
              this.changes_notif = []

              if (
                this.course.start_date != this.predata.start_date ||
                this.course.start_time != this.predata.start_time ||
                this.course.end_date != this.predata.end_date ||
                this.course.end_time != this.predata.end_time
              ) {
                this.changes_notif.push("date-change")
              }

              if (this.course.address_id != this.predata.address_id) {
                this.changes_notif.push("address-change")
              }

              if (
                this.coursetemplate.type == 1 &&
                (!this.course.start_date || !this.course.start_time || !this.course.end_date || !this.course.end_time)
              ) {
                this.$awn.alert(this.$t("courses.dates_not_set"))
                return
              }

              if (checkCourseDataChange && this.changes_notif.length) {
                this.showCourseNotifModal()
                return
              }

              axios
                .put(this.API_URL + "course", {
                  site: process.env.VUE_APP_DOMAIN,
                  subdomain: vm.SUBDOMAIN,
                  id: this.course.id,
                  name: this.course.name,
                  short_description: this.course.short_description,
                  description: this.course.description,
                  certificate_display_name: this.course.certificate_display_name,
                  coursetypegroup_id: this.course.coursetypegroup_id,
                  coursetype_id: this.course.coursetype_id,
                  coursetemplate_id: this.course.coursetemplate_id,
                  //class_id: this.course.class_id,
                  instructor_id: this.course.instructor_id,
                  stand_in: this.course.stand_in,
                  classroom_id: this.course.classroom_id,
                  address_id: this.course.address_id,
                  company_id: this.course.company_id,
                  start_date: this.course.start_date,
                  start_time: this.course.start_time,
                  end_date: this.course.end_date,
                  end_time: this.course.end_time,
                  enrolment_due_date: this.course.enrolment_due_date,
                  certificate_valid_until: this.course.certificate_valid_until,
                  certificate_issued_date: this.course.certificate_issued_date,
                  price: this.course.price,
                  //location: this.course.location,
                  num_places: this.course.num_places,
                  number_of_days: this.course.number_of_days,
                  exclude_weekends: this.course.exclude_weekends,
                  register_attendance: this.course.register_attendance,
                  adjust_time_per_day: this.course.adjust_time_per_day,
                  time_per_day: this.preSaveCourseStartEndTime(),
                  send_email_notification: this.course.send_email_notification,
                  send_sms_notification: this.organisation.sms_service ? this.course.send_sms_notification : 0,
                  klarna_checkout: this.integration_klarna ? this.course.klarna_checkout : null,
                  klarna_checkout_type: this.integration_klarna && this.course.klarna_checkout ? this.course.klarna_checkout_type : null,
                  status: this.course.status,
                  is_published: this.course.is_published,
                  allow_overbook: this.course.allow_overbook,
                  allow_reservation: this.course.allow_reservation,
                  notify_email: Boolean(sendNotification && this.courseNotifEmail),
                  notify_sms: Boolean(sendNotification && this.courseNotifSMS),
                  changes_notif: this.changes_notif
                })
                .then((res) => {
                  vm.course = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.course))

                  vm.coursetemplate = vm.course.coursetemplate
                  vm.number_of_days = vm.course.number_of_days > 0 ? vm.course.number_of_days : 1
                  vm.currentCourseTypes = vm.course.coursetemplate.coursetypes ? vm.course.coursetemplate.coursetypes.map((a) => a.id) : []
                  vm.moduletemplates = vm.course.moduletemplates
                  vm.setCourseInfoLink()
                  vm.initCourseStartEndTime()

                  vm.setPageTitle()
                  vm.cancelCourseNotifModal()

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "course",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    addressChange(id) {
      axios
        .post(this.API_URL + "request/ddlists", [
          { key: "classrooms", module: "classrooms", query: "show_all=true&query_address_id=" + id }
        ])
        .then((res) => {
          this.classrooms = res.data.classrooms
          this.$refs.address_id.focus()
        })
    },

    courseGroupChange(id, ct_id = null) {
      let query_ct = id ? "&query_coursetypegroup_id=" + id : ""

      if (this.coursetemplate.type == 2) {
        query_ct += "&query_type=2" // Long run
      }

      axios
        .post(this.API_URL + "request/ddlists", [
          { key: "coursetypes", module: "coursetypes", query: "show_all=true" + query_ct + "&sort_by=name&sort_order=asc" }
        ])
        .then((res) => {
          this.coursetypes = res.data.coursetypes
          if (ct_id) {
            this.course.coursetype_id = ct_id
          } else {
            this.course.coursetype_id = null
          }
          this.$refs.coursetype_id.focus()
        })
    },

    courseTypeChange(id) {
      let query_ct = id ? "&query_coursetype_id=" + id + "&query_status=1" : ""

      if (this.coursetemplate.type == 2) {
        query_ct += "&query_type=2" // Long run
      }

      axios
        .post(this.API_URL + "request/ddlists", [
          {
            key: "coursetemplates",
            module: "coursetemplates",
            query: "resourcetype=coursetemplate-ddlist&show_all=true" + query_ct + "&sort_by=name&sort_order=asc"
          }
        ])
        .then((res) => {
          this.coursetemplates = res.data.coursetemplates
          this.$refs.coursetype_id.focus()
          this.filterInstructorCourseType()
        })
    },

    courseTemplateChange() {
      let vm = this

      if (!this.id && this.course.coursetemplate_id) {
        axios
          .get(this.API_URL + "coursetemplate/" + this.course.coursetemplate_id)
          .then((res) => {
            let coursetemplate = res.data.data
            this.coursetemplate = coursetemplate

            if (!this.course.coursetypegroup_id) {
              vm.$set(vm.course, "coursetypegroup_id", coursetemplate.coursetypegroup_id)
            }

            if (!this.course.coursetype_id && coursetemplate.coursetypes.length > 0) {
              let ctid = coursetemplate.coursetypes[0].id
              vm.$set(vm.course, "coursetype_id", ctid)
              vm.courseGroupChange(vm.course.coursetypegroup_id, ctid)
            }

            vm.$set(vm.course, "name", coursetemplate.name)
            vm.$set(vm.course, "certificate_display_name", coursetemplate.certificate_display_name)
            vm.$set(vm.course, "short_description", coursetemplate.short_description)
            vm.$set(vm.course, "description", coursetemplate.long_description)
            vm.$set(vm.course, "info_link", coursetemplate.info_link)
            vm.$set(vm.course, "number_of_days", coursetemplate.number_of_days)
            vm.$set(vm.course, "num_places", coursetemplate.num_places)
            vm.$set(vm.course, "send_email_notification", coursetemplate.send_email_notification)
            vm.$set(vm.course, "price", coursetemplate.price)
            vm.$set(vm.course, "klarna_checkout", coursetemplate.klarna_checkout)
            vm.$set(vm.course, "klarna_checkout_type", coursetemplate.klarna_checkout_type)

            if (this.organisation.sms_service) {
              vm.$set(vm.course, "send_sms_notification", coursetemplate.send_sms_notification)
            }

            if (vm.course.start_date) {
              let start = vm.moment(vm.course.start_date, vm.MYSQL_DATE_FORMAT)

              if (coursetemplate.number_of_days) {
                let end = start.add(coursetemplate.number_of_days - 1, "days")
                vm.$set(vm.course, "end_date", vm.moment(end).format(vm.MYSQL_DATE_FORMAT))
              } else {
                vm.$set(vm.course, "end_date", vm.moment(start, vm.MYSQL_DATE_FORMAT).format(vm.MYSQL_DATE_FORMAT))
              }

              if (coursetemplate.number_of_days < 31) {
                this.$set(this.course, "register_attendance", 1)
              } else {
                this.$set(this.course, "register_attendance", 0)
              }
            }

            if (coursetemplate.valid_for && vm.course.end_date) {
              let end = vm.course.end_date ? vm.moment(vm.course.end_date, vm.MYSQL_DATE_FORMAT) : vm.moment()
              let cert_valid_until = end.add(coursetemplate.valid_for, "months").add(1, "days")
              vm.$set(vm.course, "certificate_valid_until", cert_valid_until.format(vm.MYSQL_DATE_FORMAT))
            }

            if (vm.course.end_date) {
              vm.$set(vm.course, "certificate_issued_date", vm.course.end_date)
            }

            if (this.coursetemplate.type == 2) {
              this.$set(vm.course, "start_date", null)
              this.$set(vm.course, "start_time", null)
              this.$set(vm.course, "end_date", null)
              this.$set(vm.course, "end_time", null)
              this.$set(vm.course, "enrolment_due_date", null)
              this.$set(vm.course, "certificate_valid_until", null)
              this.$set(vm.course, "certificate_issued_date", null)
            } else {
              // Check start date (4 set of codes)
              this.statuses = this.$dd_course_status().filter((i) => i.key != 1) // 1 = Upcoming
            }

            this.initCourseStartEndTime(true)
          })
          .catch((err) => console.log(err))
      }
    },

    numberOfDaysChange() {
      if (!this.course.start_date) {
        this.course.start_date = this.moment().format(this.MYSQL_DATE_FORMAT)
      }

      let start = this.moment(this.course.start_date, this.MYSQL_DATE_FORMAT)

      if (this.course.number_of_days && this.course.number_of_days > 0) {
        let number_of_days = this.course.number_of_days

        if (this.course.exclude_weekends && number_of_days > 0) {
          // Compute for weekend
          number_of_days-- // include the current date in computation
          let end = start

          while (number_of_days > 0) {
            end = start.add(1, "days")
            if (end.day() !== 6 && end.day() !== 0) {
              // 6 = Saturday, 0 = Sunday
              number_of_days -= 1
            }
          }

          this.$set(this.course, "end_date", this.moment(end).format(this.MYSQL_DATE_FORMAT))
        } else {
          // Normal date computation
          let end = start.add(this.course.number_of_days - 1, "days")
          this.$set(this.course, "end_date", this.moment(end).format(this.MYSQL_DATE_FORMAT))
        }
      } else {
        this.$set(this.course, "number_of_days", 1)
        this.$set(this.course, "end_date", this.moment(start, this.MYSQL_DATE_FORMAT).format(this.MYSQL_DATE_FORMAT))
      }

      if (this.course.number_of_days < 31) {
        this.$set(this.course, "register_attendance", 1)
      } else {
        this.$set(this.course, "register_attendance", 0)
      }

      this.initCourseStartEndTime(true)
    },

    showMoveAttendee(id) {
      this.selectedAttendee = id
      this.showRemoveAttendeeModal = true
    },
    hideMoveAttendee() {
      this.selectedAttendee = null
      this.selectedAttendees = []
      this.showRemoveAttendeeModal = false
    },
    moveAttendee(type) {
      let vm = this

      if (type == "interested-list") {
        let attendee = this.attendees.find((i) => i.id == this.selectedAttendee)

        if (attendee) {
          axios
            .post(this.API_URL + "attendee/moved-interestedlist", {
              id: this.selectedAttendee,
              course_id: this.course.id
            })
            .then((res) => {
              vm.$awn.success(vm.$t("courses.move_attendee_interested_list_success"))
              vm.hideMoveAttendee()
              vm.attendee_refresh = true
            })
            .catch((err) => {
              vm.$awn.alert(vm.$t("courses.move_attendee_interested_list_failed"))
              vm.hideMoveAttendee()
              vm.attendee_refresh = true
            })
        } else {
          vm.hideMoveAttendee()
        }
      }

      if (type == "another-course") {
        this.attendee_courselistpopup_show()
      }
      if (type == "delete") {
        this.removeAttendee(this.selectedAttendee)
      }
    },
    attendee_courselistpopup_show() {
      this.showAttendeeCourseListPopup = true
    },
    callback_attendee_courselistpopup_submit(data) {
      let ids = data.map((i) => i.id)
      let id = ids.shift()
      let vm = this

      this.showAttendeeCourseListPopup = false
      this.showRemoveAttendeeModal = false

      if (id) {
        axios
          .get(this.API_URL + "course/" + id + "?resourcetype=course-basic-list")
          .then((res) => {
            let newcourse = res.data.data

            if (vm.course.coursetemplate_id != newcourse.coursetemplate_id) {
              vm.$awn.confirm(
                vm.$t("courses.move_course_diff_template"),
                () => {
                  vm.callback_courselistpopup_cancel()
                  return
                },
                () => {
                  vm.moveAttendeeCourse(id)
                },
                {
                  labels: {
                    confirm: "",
                    confirmCancel: this.$t("global.yes"),
                    confirmOk: this.$t("global.no")
                  }
                }
              )
            } else {
              vm.moveAttendeeCourse(id)
            }
          })
          .catch((err) => console.log(err))
      } else {
        vm.callback_attendee_courselistpopup_cancel()
      }
    },
    moveAttendeeCourse(id) {
      let vm = this

      axios
        .post(this.API_URL + "attendee/moved-anothercourse", {
          id: this.selectedAttendee,
          course_id: id
        })
        .then((res) => {
          vm.$awn.success(vm.$t("courses.move_attendee_another_course_success"))
          vm.callback_attendee_courselistpopup_cancel()
          vm.attendee_refresh = true
        })
        .catch((err) => {
          vm.$awn.alert(vm.$t("courses.move_attendee_another_course_failed"))
          vm.callback_attendee_courselistpopup_cancel()
          vm.attendee_refresh = true
        })
    },
    callback_attendee_courselistpopup_cancel() {
      this.showAttendeeCourseListPopup = false
      this.hideMoveAttendee()
    },
    removeAttendee(aid, eid = null) {
      let vm = this
      //let message = eid ? this.$t("courses.attendee_remove_back_enrolment") : this.$t("courses.attendee_remove")

      axios
        .delete(this.API_URL + "attendee/remove/" + aid)
        .then((res) => {
          vm.attendee_list()
          vm.enrolment_list()
          vm.hideMoveAttendee()

          vm.$awn.success(vm.$t("global.delete_success"))
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    deleteSelectedAttendees() {
      let vm = this
      let ids = this.selectedAttendees.map((a) => a.id)

      this.$awn.confirm(
        this.$t("attendees.delete_selected_confirmation"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "attendees/delete-multiple", {
              ids: ids.join(",")
            })
            .then((res) => {
              vm.$awn.success(vm.$t("global.delete_success"))
              vm.attendee_refresh = true
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    updateSingleCourseField(id, field, value) {
      let vm = this
      axios
        .put(this.API_URL + "course/updatefield", {
          id: id,
          field: field,
          value: value
        })
        .then((res) => {
          vm.predata = JSON.parse(JSON.stringify(vm.course))
          vm.$awn.success(vm.$t("global.update_success"))

          if (field == "exclude_weekends") {
            this.updateNumberOfDays()
          }
        })
        .catch((err) => console.log(err))
    },

    updateSingleField(id, field, value) {
      let vm = this

      axios
        .put(this.API_URL + "attendee/updatefield", {
          id: id,
          field: field,
          value: value
        })
        .then((res) => {
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },

    updateSingleEnrField(id, field, value) {
      let vm = this

      axios
        .put(this.API_URL + "enrolment/updatefield", {
          id: id,
          field: field,
          value: value
        })
        .then((res) => {
          vm.$awn.success(vm.$t("global.update_success"))
          vm.enr_refresh = true
        })
        .catch((err) => console.log(err))
    },

    openUpload(action, id) {
      this.selectedParticipant = id

      if (action == "camera") this.openUploadCamera()
      if (action == "file") this.openUploadForm()
    },

    openUploadCamera() {
      this.showUploadCamera = true
      this.cameraStart()
    },
    cancelUploadCamera() {
      this.showUploadCamera = false
      this.participant_image = null
      this.selectedParticipant = null
      this.cameraStop()
    },

    openUploadForm() {
      this.showUploadForm = true
    },

    cancelUpload() {
      this.showUploadForm = false
      this.selectedParticipant = null
      this.participant_image = null
    },

    async uploadImage() {
      let vm = this
      let formData = new FormData()

      if (this.$refs.participant_image) {
        const isValid = await this.$refs.participant_image.validate()
        if (!isValid) {
          return
        }
      }

      if (!this.participant_image) {
        vm.$awn.alert(vm.$t("courses.no_image_selected"))
      } else {
        formData.append("id", this.selectedParticipant)
        formData.append("participant_image", this.participant_image)

        axios
          .post(this.API_URL + "participant/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            vm.$awn.success(vm.$t("global.update_success"))
            vm.cancelUpload()
            vm.cancelUploadCamera()
            vm.attendee_list()
          })
          .catch((err) => console.log(err))
      }
    },

    openUploadDocumentForm() {
      this.showUploadDocumentForm = true
      this.files = []
      this.file_description = null
    },
    cancelUploadDocument() {
      this.showUploadDocumentForm = false
      this.files = []
      this.file_description = null
    },
    async uploadDocument() {
      let id = this.course.id
      let vm = this
      let formData = new FormData()

      if (this.$refs.files) {
        const isValid = await this.$refs.files.validate()
        if (!isValid) {
          return
        }
      }

      formData.append("id", id)
      formData.append("description", this.file_description || null)

      this.files.forEach((file, index) => {
        formData.append("files[" + index + "]", file)
      })

      axios
        .post(this.API_URL + "course/document/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          vm.$awn.success(vm.$t("global.update_success"))
          vm.cancelUploadDocument()
          vm.document_list()
        })
        .catch((err) => console.log(err))
    },
    downloadDocument(file, preview) {
      axios({
        url: this.API_URL + "s3/download?file=" + file.filename,
        method: "GET",
        responseType: "arraybuffer"
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))

            if (!preview) {
              const link = document.createElement("a")
              link.href = url
              link.setAttribute("download", file.original_filename)
              link.click()
            } else {
              this.showPreviewModal(url, file.original_filename)
            }
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    deleteDocument(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "course/document/delete/" + id)
            .then((res) => {
              vm.document_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    restoreDocument(file) {
      let vm = this

      axios
        .post(this.API_URL + "course/document/restore/" + file.id)
        .then((res) => {
          vm.document_list()
          vm.$awn.success(vm.$t("global.restore_success"))
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    openUpdateFile(item) {
      if (item) {
        this.selectedDocument = JSON.parse(JSON.stringify(item))
        this.selectedDocument["new_original_filename"] = this.selectedDocument.original_filename
        this.selectedDocument["new_description"] = this.selectedDocument.description
        this.showFileUpdate = true
      }
    },
    updateFile() {
      if (this.selectedDocument) {
        axios
          .put(this.API_URL + "course/document/update", {
            id: this.selectedDocument.id,
            original_filename: this.selectedDocument.new_original_filename,
            description: this.selectedDocument.new_description
          })
          .then((res) => {
            this.$awn.success(this.$t("global.update_success"))
            this.document_list()
            this.cancelUpdateFile()
          })
          .catch((err) => console.log(err))
      }
    },
    cancelUpdateFile() {
      this.showFileUpdate = false
      this.selectedDocument = {}
    },
    async documentOnDrop(e) {
      this.document_dragover = false
      if (e.dataTransfer.files.length) {
        Array.from(e.dataTransfer.files).forEach((file) => {
          this.files.push(file)
        })
      }

      if (this.$refs.files) {
        await this.$refs.files.validate()
      }
    },
    async documentOnDropImage(e) {
      this.document_dragover_image = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.participant_image = file
          }
        }
      }

      if (this.$refs.participant_image) {
        await this.$refs.participant_image.validate()
      }
    },
    downloadCertificate(item) {
      let vm = this

      if (item.certificate_filename && item.p360_archived_date && item.p360_pdf_filename) {
        axios({
          url: this.API_URL + "s3/download?file=" + item.certificate_filename,
          method: "GET",
          responseType: "arraybuffer"
        })
          .then((response) => {
            if (this.$arrayBufferValidation(response.data)) {
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement("a")
              link.href = url
              link.setAttribute("download", "certificate.pdf")
              link.click()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        axios({
          url: this.API_URL + "attendee/downloadCertificate",
          method: "POST",
          data: {
            id: item.id
          },
          responseType: "arraybuffer"
        })
          .then((response) => {
            if (this.$arrayBufferValidation(response.data)) {
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement("a")
              link.href = url
              link.setAttribute("download", "certificate.pdf")
              link.click()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    show_partAndEnrPopup() {
      if (this.requestOnly) {
        this.enrlistpopup_show()
      } else {
        this.partenrlistpopup_show()
      }
    },
    partlistpopup_show() {
      this.reRenderEnrVerify++
      this.showParticipantListPopup = true
    },
    callback_partlistpopup_submit(data) {
      this.callback_partlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      if (ids && ids.length > 0) {
        axios
          .post(this.API_URL + "course/createAttendee", {
            id: this.course.id,
            participant_ids: ids.join(",")
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              let json = res.data

              if (json.status) {
                vm.$awn.success(
                  json.hasSkipUser ? vm.$t("enrolments.multi_enrolment_successful_with_skip") : vm.$t("global.create_success")
                )
              } else {
                vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
              }

              vm.attendee_refresh = true
            }
          })
          .catch((err) => console.log(err))
      }
    },
    callback_partlistpopup_cancel() {
      this.showParticipantListPopup = false
    },
    partenrlistpopup_show() {
      this.reRenderEnrVerify++
      this.showParticipantEnrolmentListPopup = true
    },
    callback_partenrlistpopup_submit(data) {
      this.callback_partenrlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      if (ids && ids.length > 0) {
        axios
          .post(this.API_URL + "course/createEnrolment", {
            id: this.course.id,
            participant_ids: ids.join(","),
            site: process.env.VUE_APP_DOMAIN,
            subdomain: vm.SUBDOMAIN
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              let json = res.data

              if (json.status) {
                vm.$awn.success(
                  json.hasSkipUser ? vm.$t("enrolments.multi_enrolment_successful_with_skip") : vm.$t("global.create_success")
                )
              } else {
                vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
              }

              vm.enr_refresh = true
            }
          })
          .catch((err) => console.log(err))
      }
    },
    callback_partenrlistpopup_cancel() {
      this.showParticipantEnrolmentListPopup = false
    },
    enrlistpopup_show() {
      this.showEnrolmentListPopup = true
    },
    callback_enrlistpopup_submit(data) {
      this.callback_enrlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      if (ids) {
        axios
          .post(this.API_URL + "enrolment/convertWaitlist", {
            course_id: this.course.id,
            ids: ids.join(",")
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              let json = res.data

              if (json.status) {
                vm.$awn.success(vm.$t("global.create_success"))
              } else {
                vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
              }

              vm.enr_refresh = true
            }
          })
          .catch((error) => {})
      }

      /*axios
                .post(this.API_URL + "course/createAttendee", {
                    id: this.course.id,
                    participant_ids: ids.join(','),
                })
                .then(res => {
                    if (typeof res.data.errors !== "undefined") {
                    } else {
                        let json = res.data

                        if(json.status) {
                            vm.$awn.success(json.hasSkipUser ? vm.$t("enrolments.multi_enrolment_successful_with_skip") : vm.$t("global.create_success"));
                        } else {
                            vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"));
                        }

                        vm.attendee_refresh = true;
                    }
                })
                .catch(err => console.log(err));*/
    },
    callback_enrlistpopup_cancel() {
      this.showEnrolmentListPopup = false
    },
    updateModuleTemplateMandatory(mt, event) {
      let vm = this

      if (event) {
        this.$awn.confirm(
          this.$t("attendees.accomplishment_mandatory_addedupdated_confirm"),
          () => {
            axios
              .put(this.API_URL + "coursemoduletemplate/field", {
                id: mt.id,
                field: "mandatory",
                value: event ? 1 : 0
              })
              .then((res) => {
                vm.silentUpdateAccomplishment()
              })
              .catch((err) => console.log(err))
          },
          () => {
            mt.mandatory = !event
          },
          {
            labels: {
              confirmOk: this.$t("global.yes"),
              confirmCancel: this.$t("global.no")
            }
          }
        )
      } else {
        axios
          .put(this.API_URL + "coursemoduletemplate/field", {
            id: mt.id,
            field: "mandatory",
            value: event ? 1 : 0
          })
          .then((res) => {
            vm.$awn.success(vm.$t("global.update_success"))
          })
          .catch((err) => console.log(err))
      }
    },
    updateModuleTemplateAddToExpertise(id, event) {
      let vm = this

      axios
        .put(this.API_URL + "coursemoduletemplate/field", {
          id: id,
          field: "add_to_expertise",
          value: event ? 1 : 0
        })
        .then((res) => {
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },
    updateModuleTemplateHideAcc(id, event, updateHideEnr = false) {
      let vm = this

      axios
        .put(this.API_URL + "coursemoduletemplate/field", {
          id: id,
          field: "hide_in_accomplishment",
          value: event ? 1 : 0
        })
        .then((res) => {
          if (updateHideEnr && event) {
            var idx = vm.moduletemplates.findIndex((i) => i.id == id)
            if (idx !== -1) {
              vm.$set(vm.moduletemplates[idx], "hide_in_enrolment", 0)
            }

            vm.updateModuleTemplateHideEnr(id, !event)
            vm.updateModuleTemplateAddToExpertise(id, !event)
          } else {
            vm.$awn.success(vm.$t("global.update_success"))
          }
        })
        .catch((err) => console.log(err))
    },
    updateModuleTemplateHideEnr(id, event, updateHideAcc = true) {
      let vm = this

      axios
        .put(this.API_URL + "coursemoduletemplate/field", {
          id: id,
          field: "hide_in_enrolment",
          value: event ? 1 : 0
        })
        .then((res) => {
          if (updateHideAcc && event) {
            var idx = vm.moduletemplates.findIndex((i) => i.id == id)
            if (idx !== -1) {
              vm.$set(vm.moduletemplates[idx], "hide_in_accomplishment", 0)
            }

            vm.updateModuleTemplateHideAcc(id, !event)
          } else {
            vm.$awn.success(vm.$t("global.update_success"))
          }
        })
        .catch((err) => console.log(err))
    },
    checkKeyPressFilterAttendees(e) {
      if (e.key == "Enter") {
        this.filterAttendees()
      }
    },
    exportExcel() {
      axios({
        url: this.API_URL + "course/export/" + this.course.id,
        method: "POST",
        responseType: "arraybuffer"
      }).then((response) => {
        if (this.$arrayBufferValidation(response.data)) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", "course_export.xlsx")
          link.click()
        }
      })
    },

    courselistpopup_show() {
      this.showCourseListPopup = true
    },
    callback_courselistpopup_submit(data) {
      let ids = data.map((i) => i.id)
      let id = ids.shift()
      let vm = this

      this.showCourseListPopup = false
      this.showRemoveEnrolmentModal = false

      if (id) {
        axios
          .get(this.API_URL + "course/" + id + "?resourcetype=course-basic-list")
          .then((res) => {
            let newcourse = res.data.data

            if (vm.course.coursetemplate_id != newcourse.coursetemplate_id) {
              vm.$awn.confirm(
                vm.$t("courses.move_course_diff_template"),
                () => {
                  vm.callback_courselistpopup_cancel()
                  return
                },
                () => {
                  vm.moveEnrolmentCourse(id)
                },
                {
                  labels: {
                    confirm: "",
                    confirmCancel: this.$t("global.yes"),
                    confirmOk: this.$t("global.no")
                  }
                }
              )
            } else {
              vm.moveEnrolmentCourse(id)
            }
          })
          .catch((err) => console.log(err))
      } else {
        vm.callback_courselistpopup_cancel()
      }
    },
    moveEnrolmentCourse(id) {
      let vm = this
      axios
        .post(this.API_URL + "enrolment/moved-anothercourse", {
          id: this.selectedEnrolment,
          course_id: id
        })
        .then((res) => {
          vm.$awn.success(vm.$t("courses.move_enrolment_another_course_success"))
          vm.callback_courselistpopup_cancel()
          vm.enr_refresh = true
        })
        .catch((err) => {
          vm.$awn.alert(vm.$t("courses.move_enrolment_another_course_failed"))
          vm.callback_courselistpopup_cancel()
          vm.enr_refresh = true
        })
    },
    callback_courselistpopup_cancel() {
      this.showCourseListPopup = false
      this.hideMoveEnrolment()
    },

    moduleOptionOrder(mid, moid, increase) {
      var data = []
      var ctr = 1

      let mt = this.moduletemplates.find((m) => m.id == mid)

      var idx = mt.moduleoptions.findIndex((i) => i.id == moid)
      var newIdx = null

      if (increase) {
        newIdx = idx++
      } else {
        newIdx = idx--
      }

      mt.moduleoptions.swapItems(idx, newIdx)

      mt.moduleoptions.forEach((item, index) => {
        item.order = ctr
        data.push({ id: item.id, order: item.order })
        ctr++
      })

      axios
        .put(this.API_URL + "coursemoduletemplate/moduleoptionorder", {
          data: data
        })
        .then((res) => {})
        .catch((err) => console.log(err))
    },

    delEnrolment(id = null) {
      let vm = this

      if (id) {
        this.$awn.confirm(
          this.$t("global.delete_message"),
          () => {
            return
          },
          () => {
            axios
              .delete(this.API_URL + "enrolment/" + id)
              .then((res) => {
                vm.hideMoveEnrolment()
                vm.enr_refresh = true
                vm.$awn.success(vm.$t("global.delete_success"))
              })
              .catch((err) => console.log(err))
          },
          {
            labels: {
              confirm: "",
              confirmCancel: this.$t("global.yes"),
              confirmOk: this.$t("global.no")
            }
          }
        )
      }
    },
    orgRedirect(id) {
      this.$router.push(this.BACKEND_URL + "/enrolments/organisations/view/" + id)
    },

    cameraCapture() {
      let capture = this.$refs.webcam.capture()
      if (capture) {
        var file = this.$dataURLtoFile(capture, "capture.jpg")
        this.participant_image = file
        this.uploadImage()
        this.cameraStop()
      }
    },
    cameraStop() {
      if (this.$refs.webcam) {
        this.$refs.webcam.stop()
      }
    },
    cameraStart() {
      if (this.$refs.webcam) {
        this.$refs.webcam.start()
      }
    },
    cameraList(cameras) {
      this.cameraDevices = cameras

      const [first] = this.cameraDevices
      if (first) {
        this.camera = first.deviceId
        this.cameraDeviceId = first.deviceId
      }
    },
    cameraChange(deviceId) {
      this.cameraDeviceId = deviceId
      this.camera = deviceId
    },
    cameraSwitch() {
      let idx = this.cameraDevices.findIndex((x) => x.deviceId === this.cameraDeviceId)
      let devicesCount = this.cameraDevices.length

      if (devicesCount > 1) {
        idx = (idx + 1) % devicesCount
        let newCamera = this.cameraDevices[idx]
        if (newCamera) {
          this.cameraChange(newCamera.deviceId)
        }
      }
    },
    silentUpdateAccomplishment() {
      this.suaId = this.course.id
      this.showSUA = true
    },
    callback_sua_update() {
      this.suaId = 0
      this.showSUA = false

      this.$awn.success(this.$t("global.update_success"))
      this.return_modal_cancel_form()
      this.loadModuleTemplates()
    },
    p360Upload(record) {
      let pid = record.participant.pid
      if (pid) {
        if (pid.length == 11) {
          let isnumeric = /^\d+$/.test(pid)
          if (isnumeric) {
            this.$awn.confirm(
              this.$t("integrations.p360_confirm"),
              () => {
                axios
                  .post(this.API_URL + "attendee/p360/upload", {
                    id: record.id
                  })
                  .then((res) => {
                    if (res.data.status == "success") {
                      this.attendee_refresh = true
                      this.$awn.success(this.$t("integrations.p360_upload_success"))
                    } else {
                      this.attendee_refresh = true
                      this.$awn.alert(this.$t("integrations.p360_upload_failed"))
                    }
                  })
                  .catch((err) => console.log(err))
              },
              () => {
                return
              },
              {
                labels: {
                  confirm: "",
                  confirmOk: this.$t("global.yes"),
                  confirmCancel: this.$t("global.no")
                }
              }
            )
            return
          }
        }
      }

      this.$awn.alert(
        this.$t("integrations.p360_invalid_pid", { name: record.participant.first_name + " " + record.participant.last_name })
      )
    },

    redirectToEnrolmentForm() {
      let link = this.enrolment_form_link

      if (link) {
        if (this.from_module == "calendar") {
          link += "?published=true"
        }

        window.open(link, "_blank")
      }
    },
    copyEnrolmentFormLink() {
      var copyText = document.getElementById("copy-enrolment-form-link")
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value)

      this.showEnrolmentFormLinkCopiedToolTip = true
      setTimeout(() => {
        this.showEnrolmentFormLinkCopiedToolTip = false
      }, 1000)
    },
    redirectToInfoLink() {
      if (this.course.info_link) {
        window.open(this.$getValidUrl(this.course.info_link), "_blank")
      }
    },
    copyInfoLink() {
      var copyText = document.getElementById("copy-info-link")
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value)

      this.showInfoLinkCopiedToolTip = true
      setTimeout(() => {
        this.showInfoLinkCopiedToolTip = false
      }, 1000)
    },
    sendemailtemplatepopup_show(module) {
      if (module == "attendee") {
        this.setpIds = this.selectedAttendees.map((a) => a.participant_id)
        this.setpIdsModule = "attendee"
      }

      if (module == "enrolment") {
        this.setpIds = this.selectedEnrolments.map((a) => a.id)
        this.setpIdsModule = "enrolment"
      }

      this.showSendEmailTemplatePopup = true
    },
    callback_sendemailtemplatepopup_send_success(data) {
      this.$awn.success(this.$t("notificationtemplates.notification_sent_successfully"))
      this.callback_sendemailtemplatepopup_cancel()
    },
    callback_sendemailtemplatepopup_send_failed(data) {
      this.$awn.alert(this.$t("notificationtemplates.notification_sent_failed"))
      this.callback_sendemailtemplatepopup_cancel()
    },
    callback_sendemailtemplatepopup_cancel() {
      this.showSendEmailTemplatePopup = false
      this.reRenderSendEmailTemplatePopup++
    },
    modtemplistpopup_show() {
      this.showModuleTemplateListPopup = true
    },
    callback_modtemplistpopup_submit(data) {
      this.callback_modtemplistpopup_cancel()

      let mt_ids = data.map((i) => i.id)
      if (mt_ids) {
        axios
          .post(this.API_URL + "course/moduletemplate", {
            id: this.course.id,
            mt_ids: mt_ids.join(",")
          })
          .then((res) => {
            this.moduletemplates = res.data.data.moduletemplates
          })
          .catch((err) => console.log(err))
      }
    },
    callback_modtemplistpopup_cancel() {
      this.showModuleTemplateListPopup = false
    },
    showPreviewModal(src, filename) {
      this.previewSrc = src
      this.previewFilename = filename
      this.previewShowModal = true
    },
    callback_close_preview() {
      this.previewSrc = null
      this.previewFilename = null
      this.previewShowModal = false
    },

    callback_attendee_updated(data) {
      let attendee = this.attendees.find((i) => i.id == data.id)
      if (attendee) {
        attendee.participant_image = data.participant_image
        attendee.participant_image_verified = data.participant_image_verified
        attendee.participant_image_updated_at = data.participant_image_updated_at
        attendee.participant.courses = data.participant.courses
      }
    },

    toggleCollapse() {
      this.collapseExpand = this.collapseExpand === 0 ? undefined : 0
      this.collapseExpandIcon =
        this.collapseExpand === 1 || this.collapseExpand == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"

      this.clpsCourseDateExpand = this.collapseExpand
      this.clpsAttendeeExpand = this.collapseExpand
      this.clpsEnrolmentExpand = this.collapseExpand
      this.clpsCourseDocumentExpand = this.collapseExpand
      this.clpsCourseDescExpand = this.collapseExpand
      this.clpsModuleTemplateExpand = this.collapseExpand
      this.clpsNotificationLogExpand = this.collapseExpand
    }
  }
}
</script>

<style scoped>
.form-modal {
  background: white;
}
.ct-td {
  padding: 9px !important;
  background: var(--v-secondary-base) !important;
}
.mt-card-title {
  background: var(--v-primary-base) !important;
}
.fab-update-image {
  bottom: 5px !important;
  right: 0px !important;
}
.fab-verify-image {
  top: 5px !important;
  right: 0px !important;
}
.v-input--selection-controls__input {
  margin-right: 0px !important;
}
.chk-num-of-days {
  margin-top: -4px !important;
  margin-left: 8px !important;
}
.tr-no-bottom-border td {
  border-bottom: 0 !important;
}
.mandatory-chkbox {
  margin-top: 0 !important;
  margin-right: 30px !important;
  height: 30px !important;
}
.mandatory-chkbox .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
